var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 388,
    viewBox: "0 0 1440 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1457.89 372.655L1412.17 379.544L1419.69 375.16L1457.89 372.655ZM1414.05 378.918L1452.88 373.281L1420.32 375.16L1414.05 378.918Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.07 331.318L1053.92 370.15L1060.19 335.076L1124.07 331.318ZM1054.55 368.897L1123.44 331.945L1060.81 335.076L1054.55 368.897Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.75 295.619L1451 335.077L1420.32 375.16L1419.69 375.16L1449.75 295.619ZM1450.38 335.077L1449.75 296.872L1420.94 373.908L1450.38 335.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.75 295.619L1458.52 373.281L1419.69 375.786L1449.75 295.619ZM1457.89 372.655L1449.75 296.871L1420.32 375.16L1457.89 372.655Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.48 331.319L1331.38 335.703L1333.88 343.845L1319.48 331.319ZM1330.75 335.703L1320.73 331.945L1333.26 342.592L1330.75 335.703Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.88 293.74L1274.39 299.377L1274.39 300.003L1221.77 375.16L1209.88 293.74ZM1273.13 300.003L1209.88 294.366L1221.77 373.908L1273.13 300.003Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.5 293.74L1202.36 362.634L1201.73 362.008L1156.01 299.377L1210.5 293.74ZM1202.36 361.381L1209.88 294.366L1157.27 300.003L1202.36 361.381Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.5 294.366L1222.4 375.16L1202.36 362.008L1210.5 294.366ZM1221.78 373.908L1210.5 296.245L1202.99 362.008L1221.78 373.908Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.64 299.377L1158.52 318.792L1145.99 328.813L1156.64 299.377ZM1157.89 318.792L1156.64 300.629L1147.24 326.934L1157.89 318.792Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.64 299.377L1202.36 362.008L1201.73 362.634L1145.99 328.813L1156.64 299.377ZM1201.73 361.381L1157.26 300.629L1147.24 328.187L1201.73 361.381Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 318.792L1124.7 331.945L1092.75 341.339L1092.75 340.713L1158.52 318.792ZM1105.91 336.329L1124.7 330.692L1144.11 323.803L1105.91 336.329Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 318.792L1147.24 328.187L1124.7 331.319L1124.7 330.692L1158.52 318.792ZM1146.62 327.561L1157.26 319.419L1126.58 330.692L1146.62 327.561Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.99 328.813L1093.38 340.713L1060.19 335.076L1060.19 334.45L1083.99 328.813ZM1092.13 340.087L1083.99 329.44L1061.44 335.076L1092.13 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.07 331.318L1092.13 341.339L1059.56 335.703L1059.56 335.076L1124.07 331.318ZM1092.75 340.087L1122.82 331.318L1062.69 334.45L1092.75 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.57 296.871L1450.38 335.076L1412.8 271.193L1483.57 291.861L1483.57 291.235L1411.55 270.566L1450.38 335.703L1483.57 297.498L1483.57 296.871Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.32 256.787L1412.8 270.566L1412.8 306.892L1412.17 306.892L1363.32 256.787ZM1412.17 271.193L1364.57 258.04L1412.17 306.892L1412.17 271.193Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.17 269.94L1450.38 335.076L1449.75 335.076L1410.92 306.892L1411.55 306.892L1412.17 269.94ZM1449.75 334.45L1412.8 271.819L1412.8 306.892L1449.75 334.45Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.95 257.414L1332.01 335.703L1331.38 335.703L1342.65 298.124L1363.95 257.414ZM1332.63 331.318L1361.44 262.424L1342.65 298.124L1332.63 331.318Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.95 256.787L1412.8 306.892L1331.38 335.703L1363.95 256.787ZM1412.17 306.892L1363.95 257.414L1331.38 335.076L1412.17 306.892Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.85 293.113L1343.28 297.497L1319.48 331.945L1318.85 293.113ZM1342.03 298.124L1318.85 294.366L1319.48 331.318L1342.03 298.124Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.65 297.498L1331.38 336.329L1318.85 331.945L1342.65 297.498ZM1330.75 335.703L1342.03 299.377L1319.48 331.318L1330.75 335.703Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.95 278.082L1318.85 293.74L1318.85 294.366L1273.76 300.629L1244.95 278.082ZM1317.6 293.74L1246.2 278.708L1274.39 299.377L1317.6 293.74Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.85 293.74L1319.48 331.945L1273.76 300.003L1318.85 293.74ZM1318.85 330.692L1318.23 293.74L1274.39 299.376L1318.85 330.692Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.37 267.435L1245.57 278.082L1209.88 294.366L1209.25 294.992L1209.25 294.366L1207.37 267.435ZM1244.32 278.082L1208 268.061L1210.5 293.74L1244.32 278.082Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.95 278.082L1274.39 300.003L1209.25 294.366L1209.88 293.74L1244.95 278.082ZM1273.13 299.377L1244.95 278.082L1211.13 293.74L1273.13 299.377Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208 267.435L1157.27 300.003L1157.27 299.377L1185.45 269.94L1208 267.435ZM1158.52 298.75L1207.37 268.061L1186.08 270.566L1158.52 298.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208 267.435L1210.5 294.366L1157.27 300.003L1157.27 299.377L1208 267.435ZM1209.88 293.74L1207.37 268.061L1157.27 299.377L1209.88 293.74Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.91 258.666L1185.45 269.94L1158.52 318.792L1157.89 318.792L1167.91 258.666ZM1184.82 269.94L1167.91 259.293L1158.52 316.913L1184.82 269.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.82 269.94L1157.89 319.418L1156.01 299.377L1184.82 269.94ZM1158.52 318.166L1184.2 271.819L1157.27 300.003L1158.52 318.166Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.54 258.666L1092.76 340.713L1092.13 341.339L1092.13 340.713L1103.4 279.335L1168.54 258.666ZM1092.76 340.087L1167.29 259.919L1104.66 279.335L1092.76 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.91 258.666L1158.52 319.418L1092.75 341.339L1092.13 341.339L1167.91 258.666ZM1158.52 318.792L1167.91 259.919L1093.38 340.087L1158.52 318.792Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.87 258.04L1104.65 278.708L1084.61 328.813L1083.99 329.439L1083.99 328.813L1085.87 258.04ZM1103.4 279.335L1085.87 259.293L1083.99 327.561L1103.4 279.335Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.4 279.335L1092.13 341.339L1083.36 329.439L1082.73 330.066L1082.73 329.439L1103.4 279.335ZM1092.13 340.087L1102.78 281.214L1083.36 328.813L1092.13 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.57 287.477L1483.57 286.85L1440.98 227.977L1483.57 223.593L1439.73 227.351L1483.57 287.477Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.03 215.451L1440.98 227.351L1412.17 271.193L1404.03 215.451ZM1439.73 227.977L1404.03 216.077L1411.55 270.566L1439.73 227.977Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.57 291.861L1483.57 291.235L1412.8 271.193L1440.36 227.977L1483.57 287.477L1483.57 286.85L1440.36 227.351L1412.17 271.193L1483.57 291.861Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.03 215.451L1363.95 257.414L1363.32 257.414L1381.48 228.604L1404.03 215.451ZM1365.2 255.535L1402.78 216.704L1382.11 228.604L1365.2 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.66 215.451L1412.8 271.193L1363.95 257.414L1404.66 215.451ZM1412.17 270.566L1404.66 216.077L1364.57 256.787L1412.17 270.566Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.48 228.604L1342.65 298.124L1342.03 298.124L1342.03 297.498L1347.04 263.051L1381.48 228.604ZM1343.28 296.871L1380.86 230.482L1347.66 264.303L1343.28 296.871Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.48 228.604L1342.65 298.124L1342.03 298.124L1342.03 297.498L1363.32 256.788L1381.48 228.604ZM1349.54 284.971L1375.85 237.998L1363.95 257.414L1349.54 284.971Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.45 244.887L1347.66 263.05L1318.85 293.74L1318.85 294.366L1318.85 293.74L1304.45 244.887ZM1347.04 263.677L1305.07 246.14L1318.85 293.74L1347.04 263.677Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.66 263.051L1342.65 298.124L1318.23 293.74L1318.23 293.114L1347.66 263.051ZM1342.65 297.498L1347.04 264.303L1319.48 293.74L1342.65 297.498Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.55 215.451L1305.07 245.514L1245.57 278.082L1244.95 278.708L1244.95 277.456L1292.55 215.451ZM1304.45 245.514L1292.55 216.703L1245.57 277.456L1304.45 245.514Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.07 244.888L1319.48 293.74L1244.95 278.082L1244.95 277.456L1305.07 244.888ZM1318.23 293.114L1304.45 245.514L1245.57 277.456L1318.23 293.114Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.55 216.077L1208 268.061L1196.72 243.009L1292.55 216.077ZM1208 267.435L1291.3 216.704L1196.72 243.009L1208 267.435Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.55 216.077L1244.95 278.708L1207.37 268.061L1208 267.435L1292.55 216.077ZM1244.95 278.082L1291.92 217.33L1208.62 267.435L1244.95 278.082Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.72 242.382L1201.11 255.535L1185.45 269.94L1184.82 269.94L1196.72 242.382ZM1200.48 255.535L1196.72 243.635L1186.08 269.314L1200.48 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.1 242.382L1208 268.061L1184.82 270.566L1196.1 242.382ZM1207.37 267.435L1196.1 243.635L1185.45 269.94L1207.37 267.435Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.7 236.119L1200.48 255.535L1200.48 256.161L1167.91 259.919L1124.7 236.119ZM1199.23 255.535L1126.58 237.372L1167.91 259.293L1199.23 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.11 255.535L1184.82 270.566L1167.29 259.919L1166.66 259.293L1167.29 259.293L1167.29 258.666L1167.91 259.293L1201.11 255.535ZM1184.82 269.94L1199.23 256.161L1167.91 259.293L1184.82 269.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.85 224.219L1104.65 278.708L1104.03 278.708L1124.7 236.119L1137.85 224.219ZM1106.53 274.95L1137.22 226.098L1125.95 236.745L1106.53 274.95Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.7 236.119L1168.54 259.293L1103.4 279.335L1124.7 236.119ZM1167.29 259.293L1125.32 236.746L1104.66 278.708L1167.29 259.293Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.48 224.219L1085.87 258.666L1040.15 224.846L1138.48 224.219ZM1085.87 258.666L1137.22 224.846L1041.4 225.472L1085.87 258.666Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.85 224.219L1104.03 279.335L1085.87 258.666L1137.85 224.219ZM1104.03 278.708L1137.22 225.472L1086.49 258.666L1104.03 278.708Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.3 182.257L1439.73 227.977L1429.71 192.904L1472.3 182.257ZM1440.36 227.351L1471.05 183.509L1430.34 194.156L1440.36 227.351Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430.96 192.904L1427.83 211.067L1404.66 216.077L1430.96 192.904ZM1427.2 210.44L1430.34 194.156L1405.28 215.451L1427.2 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430.34 192.904L1440.36 227.977L1403.41 216.077L1404.03 216.077L1430.34 192.904ZM1439.73 227.351L1430.34 194.156L1404.66 216.077L1439.73 227.351Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.25 201.672L1427.83 211.067L1380.86 229.23L1380.86 228.603L1390.25 201.672ZM1426.58 210.44L1390.88 201.672L1382.11 227.977L1426.58 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.21 210.44L1381.48 229.23L1381.48 228.603L1404.03 216.077L1427.21 210.44ZM1384.62 227.351L1424.07 211.693L1404.03 216.077L1384.62 227.351Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.04 177.246L1390.88 201.672L1347.04 264.303L1347.04 177.246ZM1390.25 201.672L1347.66 177.872L1347.66 263.051L1390.25 201.672Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.25 201.672L1382.11 228.603L1347.66 263.677L1347.04 263.677L1390.25 201.672ZM1381.48 228.603L1389.63 202.925L1348.92 261.172L1381.48 228.603Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.04 177.246L1334.51 213.572L1305.07 245.514L1304.45 245.514L1347.04 177.246ZM1334.51 213.572L1346.41 179.125L1306.33 243.009L1334.51 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.66 176.62L1347.66 263.677L1304.45 245.514L1347.66 176.62ZM1347.04 263.05L1347.04 177.872L1305.07 244.887L1347.04 263.05Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.84 201.672L1334.51 213.572L1334.51 214.198L1292.55 216.704L1251.84 201.672ZM1332.01 213.572L1253.72 202.298L1292.55 216.077L1332.01 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.14 213.572L1305.07 246.14L1292.55 216.077L1335.14 213.572ZM1305.07 244.888L1333.88 214.198L1293.17 216.704L1305.07 244.888Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.84 201.672L1196.72 243.635L1196.1 243.635L1196.1 243.009L1209.25 221.714L1251.84 201.672ZM1197.35 242.382L1249.96 202.925L1209.88 221.714L1197.35 242.382Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.84 201.672L1293.8 216.077L1196.72 243.009L1251.84 201.672ZM1291.92 216.077L1251.84 202.299L1197.98 243.009L1291.92 216.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.91 196.662L1209.25 221.714L1200.48 256.161L1167.91 196.662ZM1209.25 221.714L1169.79 197.288L1201.11 254.909L1209.25 221.714Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.25 221.714L1201.11 255.535L1201.11 256.161L1201.11 255.535L1200.48 256.161L1200.48 255.535L1196.1 243.009L1209.25 221.714ZM1200.48 254.909L1208.62 223.593L1196.72 243.635L1200.48 254.909Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.16 196.662L1124.7 236.746L1125.32 205.43L1169.16 196.662ZM1125.32 236.119L1167.91 197.914L1125.32 206.056L1125.32 236.119Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.54 196.662L1201.11 256.161L1124.7 236.745L1168.54 196.662ZM1199.85 255.535L1168.54 197.914L1125.32 236.745L1199.85 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.32 205.43L1138.48 224.846L1109.04 215.451L1125.32 205.43ZM1137.22 224.219L1125.32 206.056L1109.67 215.451L1137.22 224.219Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.32 204.804L1138.48 224.846L1125.32 237.372L1125.32 204.804ZM1137.22 224.846L1125.32 206.683L1124.7 236.119L1137.22 224.846Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.57 214.198L1109.04 215.451L1109.04 216.077L1040.14 226.098L1064.57 214.198ZM1106.53 216.077L1065.2 214.825L1042.65 224.846L1106.53 216.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.04 215.451L1137.85 224.219L1137.85 224.846L1040.77 225.472L1040.77 224.846L1109.04 215.451ZM1135.97 224.219L1109.04 215.451L1043.9 224.846L1135.97 224.219Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.16 154.699L1469.17 185.388L1429.71 194.156L1430.34 193.53L1464.16 154.699ZM1469.17 184.762L1464.16 155.951L1430.96 192.904L1469.17 184.762Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.67 182.256L1469.17 185.388L1429.71 194.156L1430.34 193.53L1471.67 182.256ZM1469.17 184.762L1471.05 183.509L1441.61 191.025L1469.17 184.762Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.16 155.325L1427.21 211.693L1427.21 211.067L1429.71 175.993L1464.16 155.325ZM1427.83 209.814L1463.53 155.951L1430.34 175.367L1427.83 209.814Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.16 155.325L1427.83 211.067L1427.21 211.067L1430.34 193.53L1464.16 155.325ZM1427.83 209.814L1462.28 158.457L1430.96 194.156L1427.83 209.814Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430.34 175.367L1390.88 202.299L1369.58 186.014L1430.34 175.367ZM1390.88 201.672L1429.08 175.994L1370.21 186.014L1390.88 201.672Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430.34 174.741L1427.83 211.067L1390.88 202.299L1430.34 174.741ZM1427.21 210.441L1429.71 175.993L1390.88 201.672L1427.21 210.441Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.15 143.425L1370.84 186.641L1347.66 177.872L1347.04 177.246L1347.66 177.246L1340.15 143.425ZM1368.96 185.388L1340.15 144.678L1347.66 177.246L1368.96 185.388Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.41 176.62L1369.58 186.015L1390.25 201.672L1390.25 202.299L1347.04 177.872L1346.41 176.62ZM1369.58 186.015L1350.17 178.499L1387.75 199.167L1369.58 186.015Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.15 143.425L1335.14 214.198L1284.41 157.204L1285.03 157.204L1340.15 143.425ZM1334.51 212.946L1339.52 144.051L1285.03 157.83L1334.51 212.946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.15 143.425L1347.66 177.246L1334.51 213.572L1333.88 213.572L1340.15 143.425ZM1347.04 177.246L1339.52 145.304L1334.51 212.319L1347.04 177.246Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.03 157.204L1251.84 201.672L1251.84 202.299L1251.84 201.672L1251.84 201.046L1251.21 160.336L1285.03 157.204ZM1251.84 201.046L1284.41 157.831L1251.84 161.588L1251.84 201.046Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.41 157.204L1335.14 214.198L1251.84 202.298L1284.41 157.204ZM1333.88 213.572L1284.41 158.457L1251.84 201.672L1333.88 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.84 160.962L1209.88 221.714L1209.25 221.714L1217.39 162.215L1251.84 160.962ZM1209.88 221.088L1251.21 162.215L1218.02 163.467L1209.88 221.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.21 160.962L1251.84 201.672L1208.62 222.34L1251.21 160.962ZM1251.21 201.672L1250.59 162.214L1209.88 221.088L1251.21 201.672Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.67 137.162L1218.02 162.841L1169.16 197.288L1168.54 197.288L1171.67 137.162ZM1216.76 162.841L1171.67 137.788L1168.54 196.662L1216.76 162.841Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.02 162.215L1209.87 222.34L1168.54 197.288L1169.16 197.288L1218.02 162.215ZM1209.25 221.714L1217.39 163.467L1169.16 197.288L1209.25 221.714Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.67 137.162L1161.02 186.641L1125.32 205.43L1125.32 204.804L1171.67 137.162ZM1160.4 186.641L1171.04 138.415L1125.95 204.804L1160.4 186.641Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.3 136.536L1169.16 197.288L1125.32 206.056L1172.3 136.536ZM1168.54 196.662L1171.67 137.789L1125.95 204.804L1168.54 196.662Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.64 140.294L1161.02 186.641L1160.4 186.641L1109.04 215.451L1099.64 140.294ZM1160.4 186.641L1100.27 141.546L1109.67 215.451L1160.4 186.641Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.4 186.641L1109.04 216.077L1109.04 215.451L1125.32 205.43L1160.4 186.641ZM1117.81 210.44L1141.61 197.288L1125.32 206.056L1117.81 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.27 140.294L1064.57 214.825L1063.94 214.825L1077.72 154.699L1100.27 140.294ZM1065.2 212.946L1099.02 142.173L1077.72 155.325L1065.2 212.946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.27 140.294L1109.67 216.077L1065.2 214.825L1100.27 140.294ZM1109.04 215.451L1099.64 142.172L1065.2 214.825L1109.04 215.451Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.79 106.473L1457.89 111.483L1430.34 175.367L1430.34 175.993L1430.34 175.367L1407.79 106.473ZM1457.27 112.11L1409.04 107.099L1430.34 174.741L1457.27 112.11Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.27 110.857L1464.78 155.325L1430.34 175.367L1430.34 174.741L1457.27 110.857ZM1464.16 155.325L1457.27 112.736L1430.34 174.741L1464.16 155.325Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.26 99.5835L1408.42 106.473L1370.21 186.014L1369.58 186.014L1395.26 99.5835ZM1407.79 107.099L1395.26 100.21L1370.84 183.509L1407.79 107.099Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.42 105.847L1430.34 175.993L1369.58 186.641L1408.42 105.847ZM1429.71 175.367L1408.42 107.725L1370.21 186.014L1429.71 175.367Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.01 95.1993L1395.89 99.5834L1339.52 144.052L1332.01 95.1993ZM1394.64 99.5834L1332.63 95.8256L1340.15 142.799L1394.64 99.5834Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.26 98.9571L1369.58 186.641L1339.52 144.051L1395.26 98.9571ZM1369.58 185.388L1394.64 100.21L1340.15 143.425L1369.58 185.388Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.01 95.1992L1284.41 157.83L1284.41 157.204L1284.41 130.899L1332.01 95.1992ZM1285.03 157.204L1331.38 97.0781L1285.66 131.525L1285.03 157.204Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.63 95.1994L1340.15 144.052L1284.41 158.457L1332.63 95.1994ZM1339.52 143.425L1332.01 96.452L1285.03 157.204L1339.52 143.425Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.52 129.646L1285.03 131.525L1251.21 162.215L1250.59 161.588L1277.52 129.646ZM1284.41 131.525L1278.14 130.273L1253.72 159.709L1284.41 131.525Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.03 130.899L1285.03 157.83L1250.59 161.588L1285.03 130.899ZM1284.41 157.83L1284.41 132.152L1251.84 160.962L1284.41 157.83Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.67 119.625L1278.77 129.646L1278.14 129.646L1217.39 162.841L1217.39 162.215L1233.67 119.625ZM1277.52 129.646L1234.3 120.252L1218.02 162.215L1277.52 129.646Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.52 129.646L1251.21 161.588L1217.39 162.841L1217.39 162.215L1277.52 129.646ZM1251.21 160.962L1276.89 130.273L1218.64 162.215L1251.21 160.962Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.3 119.625L1172.3 137.788L1162.28 122.131L1234.3 119.625ZM1172.3 137.162L1232.42 120.252L1162.9 122.131L1172.3 137.162Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.3 119.625L1217.39 162.841L1171.67 137.162L1234.3 119.625ZM1217.39 162.215L1233.68 120.252L1172.92 137.162L1217.39 162.215Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.28 121.504L1161.02 186.641L1131.59 137.162L1162.28 121.504ZM1160.4 186.014L1161.65 122.131L1131.59 137.788L1160.4 186.014Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.65 120.878L1172.3 137.162L1161.02 187.267L1160.4 186.641L1161.65 120.878ZM1171.67 137.162L1162.28 122.131L1161.02 184.136L1171.67 137.162Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.24 107.725L1131.59 138.415L1099.02 141.546L1085.24 107.725ZM1130.96 137.788L1086.49 108.978L1100.27 140.92L1130.96 137.788Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131.59 137.788L1161.02 186.641L1160.4 186.641L1099.02 140.294L1099.64 140.294L1131.59 137.788ZM1159.77 186.014L1130.96 138.415L1100.27 141.546L1159.77 186.014Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.87 108.352L1090.88 137.162L1077.72 155.325L1077.1 155.325L1085.87 108.352ZM1090.25 136.536L1085.87 109.605L1077.72 154.073L1090.25 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.87 107.099L1100.27 140.92L1077.1 155.325L1085.87 107.099ZM1099.64 140.92L1085.87 108.978L1077.72 154.073L1099.64 140.92Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.93 100.21L1482.32 102.089L1482.32 102.715L1408.42 107.099L1415.93 100.21ZM1477.31 102.089L1416.56 100.21L1409.04 106.473L1477.31 102.089Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.32 102.089L1457.89 112.11L1407.79 107.099L1408.42 106.473L1482.32 102.089ZM1457.27 111.483L1480.44 102.089L1410.92 106.473L1457.27 111.483Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.51 93.3203L1416.56 99.5834L1416.56 100.21L1395.26 99.5834L1391.51 93.3203ZM1414.05 99.5834L1392.13 93.9466L1395.26 98.9571L1414.05 99.5834Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.64 99.5834L1416.56 100.21L1407.79 107.099L1394.64 99.5834ZM1415.31 100.21L1395.89 99.5834L1407.79 105.846L1415.31 100.21Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.13 93.3204L1323.24 104.594L1332.63 95.1993L1392.13 93.3204ZM1324.49 103.968L1388.37 93.9467L1332.63 95.8256L1324.49 103.968Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392.13 93.3204L1395.89 99.5835L1332.63 95.8256L1332.63 95.1993L1392.13 93.3204ZM1394.64 99.5835L1391.51 93.9467L1337.02 95.8256L1394.64 99.5835Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.1 97.0781L1323.86 104.594L1285.03 131.525L1285.03 130.899L1315.1 97.0781ZM1323.24 104.594L1315.1 98.3307L1286.29 130.273L1323.24 104.594Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.01 95.1991L1323.24 104.594L1284.41 131.525L1284.41 130.899L1332.01 95.1991ZM1295.68 124.009L1323.86 104.594L1330.13 98.3307L1295.68 124.009Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.01 84.5521L1315.72 97.7046L1278.14 130.273L1275.01 84.5521ZM1314.47 97.7046L1275.01 85.1784L1277.52 129.02L1314.47 97.7046Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.1 97.7044L1285.03 131.525L1278.14 129.646L1315.1 97.7044ZM1285.03 130.899L1312.59 100.21L1278.77 129.646L1285.03 130.899Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.64 84.5522L1233.67 120.878L1233.67 120.252L1218.64 93.3205L1275.64 84.5522ZM1234.3 119.626L1274.39 85.1785L1219.27 93.3205L1234.3 119.626Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.64 84.5521L1278.14 130.273L1234.3 120.252L1234.3 119.625L1275.64 84.5521ZM1277.52 129.646L1275.01 85.8047L1234.3 120.252L1277.52 129.646Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.27 92.6941L1162.28 121.504L1161.65 121.504L1161.65 120.878L1193.59 93.3204L1219.27 92.6941ZM1163.53 120.878L1218.02 93.3204L1194.22 93.9467L1163.53 120.878Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.27 92.694L1234.3 120.252L1233.68 120.252L1161.65 122.131L1161.65 121.504L1219.27 92.694ZM1233.68 119.625L1219.27 93.3203L1163.53 121.504L1233.68 119.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.84 93.9467L1194.22 94.5731L1131.59 138.415L1130.96 137.788L1166.03 96.452L1194.84 93.9467ZM1132.84 136.536L1192.96 94.5731L1166.66 97.0783L1132.84 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.59 93.9466L1161.65 122.131L1130.96 137.788L1130.96 137.162L1193.59 93.9466ZM1134.72 135.909L1162.28 121.504L1191.09 97.0781L1134.72 135.909Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.61 93.9467L1166.66 96.4519L1166.66 97.0782L1085.87 108.352L1085.87 107.725L1141.61 93.9467ZM1164.78 97.0782L1141.61 94.573L1090.25 107.725L1164.78 97.0782Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.29 96.4518L1131.59 137.788L1085.87 107.725L1167.29 96.4518ZM1131.59 137.788L1166.03 97.7045L1087.12 108.978L1131.59 137.788Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.41 57.6207L1142.23 93.9468L1090.88 136.536L1046.41 57.6207ZM1140.98 93.9468L1047.03 58.2471L1090.25 135.91L1140.98 93.9468Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.61 93.9466L1090.25 137.162L1085.87 107.725L1141.61 93.9466ZM1090.88 136.536L1140.98 94.573L1086.49 108.352L1090.88 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.1 50.1049L1377.73 67.0153L1377.1 67.0153L1323.24 104.594L1323.24 103.968L1315.1 50.1049ZM1376.47 67.0153L1315.72 50.7313L1323.86 103.968L1376.47 67.0153Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.1 66.389L1392.13 93.9467L1391.51 93.9467L1323.86 104.594L1323.86 103.968L1377.1 66.389ZM1391.51 93.3204L1377.1 67.0153L1324.49 103.968L1391.51 93.3204Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.01 18.1631L1315.1 50.105L1315.1 97.7046L1314.47 97.7046L1275.01 18.1631ZM1315.1 50.105L1275.64 19.4157L1315.1 96.452L1315.1 50.105Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.1 50.1049L1323.86 104.594L1315.1 97.7046L1315.1 50.1049ZM1323.24 103.968L1315.1 53.2365L1315.1 97.7046L1323.24 103.968Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.39 17.5367L1293.17 46.9734L1275.01 84.552L1274.39 84.552L1274.39 17.5367ZM1293.17 47.5997L1275.01 19.4157L1275.01 83.9257L1293.17 47.5997Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.01 18.163L1315.72 98.3308L1275.01 85.1783L1275.01 18.163ZM1314.47 97.0782L1275.01 19.4156L1275.01 84.552L1314.47 97.0782Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.28 35.6996L1293.8 46.9732L1293.17 47.5995L1218.64 93.9465L1224.28 35.6996ZM1292.55 47.5995L1224.28 36.3259L1218.64 92.6939L1292.55 47.5995Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.8 46.9733L1275.01 85.1783L1218.64 93.3203L1293.8 46.9733ZM1275.01 84.552L1292.55 48.226L1219.9 92.694L1275.01 84.552Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.91 35.6998L1194.22 94.573L1193.59 94.573L1214.26 41.3366L1224.91 35.6998ZM1195.47 90.1888L1223.65 36.3261L1214.26 41.9629L1195.47 90.1888Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.28 35.6998L1219.27 93.3204L1193.59 94.573L1194.22 93.9467L1224.28 35.6998ZM1218.64 92.694L1224.28 36.9524L1194.22 93.9467L1218.64 92.694Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.26 41.3365L1194.22 93.9466L1166.66 96.4519L1166.03 96.4519L1166.03 95.8256L1214.26 41.3365ZM1193.59 93.9466L1213.01 42.5891L1166.66 96.4519L1193.59 93.9466Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.14 0.626556L1301.94 33.821L1274.39 19.4159L1335.14 0.626556ZM1301.94 32.5684L1333.88 1.25286L1275.01 18.7896L1301.94 32.5684Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.14 -0.00012207L1315.1 50.1047L1274.39 18.1629L1335.14 -0.00012207ZM1315.1 50.1047L1334.51 1.2525L1275.01 18.7892L1315.1 50.1047Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.39 18.1631L1302.57 33.1946L1293.8 48.2261L1274.39 18.1631ZM1301.94 33.1946L1275.64 19.4158L1293.17 46.9734L1301.94 33.1946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.02 5.01065L1224.28 36.3262L1214.26 41.9631L1214.26 42.5894L1214.26 41.9631L1214.26 41.3368L1218.02 5.01065ZM1224.28 35.6999L1218.02 6.26328L1214.26 41.3368L1224.28 35.6999Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.52 341.966L1061.44 386.434L1043.9 365.766L1101.52 341.966ZM1061.44 385.808L1100.9 343.218L1044.53 366.392L1061.44 385.808Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.9 365.765L998.182 372.655L1005.7 368.271L1043.9 365.765ZM999.435 372.028L1038.89 366.392L1006.32 368.271L999.435 372.028Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.9 365.766L1062.07 386.434L998.182 372.655L998.808 372.029L1043.9 365.766ZM1060.81 385.808L1043.9 366.392L1000.06 372.655L1060.81 385.808Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.209 363.886L1006.32 368.271L1006.32 368.897L962.482 373.907L951.209 363.886ZM1003.19 368.271L951.835 364.513L961.856 373.281L1003.19 368.271Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.7 368.271L998.182 373.281L961.856 373.907L961.23 373.907L961.23 373.281L1005.7 368.271ZM998.809 372.029L1005.07 368.271L967.493 372.655L998.809 372.029Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.42 305.013L1117.18 318.166L1102.15 342.592L1101.52 342.592L1113.42 305.013ZM1116.55 317.54L1113.42 306.266L1102.78 340.713L1116.55 317.54Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.76 288.103L1114.05 305.64L1044.53 366.392L1035.76 288.103ZM1112.8 305.64L1035.76 288.729L1044.53 365.139L1112.8 305.64Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.05 305.013L1102.15 342.592L1044.53 365.766L1114.05 305.013ZM1101.52 341.966L1112.8 306.266L1045.16 365.139L1101.52 341.966Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.76 288.729L1037.01 328.187L1006.32 368.271L1005.7 368.271L1005.7 367.644L1035.76 288.729ZM1036.39 328.187L1035.76 289.982L1006.95 367.018L1036.39 328.187Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.76 288.729L1044.53 366.392L1005.7 368.897L1005.7 368.271L1035.76 288.729ZM1043.9 365.766L1035.76 289.982L1006.32 367.645L1043.9 365.766Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.182 300.003L1037.01 328.187L951.835 364.513L951.835 363.887L998.182 300.003ZM1035.76 328.187L998.182 300.629L952.462 363.887L1035.76 328.187Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.01 327.561L1005.7 368.271L951.835 363.887L951.835 363.26L952.462 363.26L1037.01 327.561ZM1005.7 367.644L1035.76 328.187L953.088 363.26L1005.7 367.644Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.488 324.429L917.388 328.813L919.893 336.955L905.488 324.429ZM916.762 328.813L906.114 325.055L918.641 335.703L916.762 328.813Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.884 286.85L860.394 292.487L808.41 367.645L795.884 286.85ZM859.141 293.114L795.884 287.477L807.784 367.018L859.141 293.114Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.51 286.85L788.368 355.745L787.742 355.118L742.021 292.487L796.51 286.85ZM788.368 354.492L795.884 287.477L743.274 293.114L788.368 354.492Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.51 286.85L807.783 367.645L787.742 354.492L796.51 286.85ZM807.157 367.018L795.884 289.356L788.368 354.492L807.157 367.018Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.647 292.487L744.526 311.903L732 321.924L742.647 292.487ZM743.9 311.903L742.647 293.74L733.253 320.045L743.9 311.903Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.647 291.861L788.368 354.492L788.368 355.118L732.626 321.297L742.647 291.861ZM787.115 353.866L742.647 293.113L732.626 320.671L787.115 353.866Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 316.287L744.526 311.903L744.526 311.276L732 315.661L732 316.287Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 316.287L743.274 312.529L732.626 320.671L732 320.671L732 321.298L732.626 321.298L744.526 311.903L732 316.287Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.52 258.04L1114.05 306.266L1095.26 294.366L1101.52 258.04ZM1112.8 305.013L1100.9 259.293L1095.26 293.74L1112.8 305.013Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.9 258.04L1073.34 286.224L1035.76 289.356L1035.76 288.729L1100.9 258.04ZM1073.34 285.598L1099.64 259.293L1037.01 288.729L1073.34 285.598Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.52 258.04L1114.05 306.266L1113.42 306.266L1035.76 289.356L1101.52 258.04ZM1112.8 305.64L1100.9 258.666L1036.39 288.729L1112.8 305.64Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.556 263.677L1073.97 285.598L1036.39 328.813L997.556 263.677ZM1073.34 285.598L998.808 264.303L1036.39 327.561L1073.34 285.598Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.97 285.598L1035.76 328.813L1035.13 288.729L1073.97 285.598ZM1036.39 327.561L1072.71 286.224L1035.76 289.356L1036.39 327.561Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.33 249.898L998.808 263.677L998.808 300.003L998.182 300.003L949.33 249.898ZM998.182 264.303L950.582 251.151L998.182 300.003L998.182 264.303Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.182 263.051L1036.39 328.187L1035.76 328.187L996.929 300.003L997.556 300.003L998.182 263.051ZM1035.76 326.934L998.808 264.303L998.808 299.377L1035.76 326.934Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.33 250.524L917.388 328.813L916.762 329.439L916.762 328.813L928.036 291.234L949.33 250.524ZM918.641 324.429L947.451 255.535L928.662 291.234L918.641 324.429Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.956 249.898L998.808 300.003L998.182 300.003L916.762 328.813L916.135 329.439L916.762 328.813L949.956 249.898ZM997.556 300.003L949.33 250.524L916.762 328.187L997.556 300.003Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.236 286.224L928.662 290.608L904.862 325.055L904.862 324.429L904.236 286.224ZM928.035 291.235L904.862 287.477L905.488 323.803L928.035 291.235Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.662 290.608L917.388 328.813L904.862 324.429L928.662 290.608ZM916.762 328.187L928.035 292.487L905.488 324.429L916.762 328.187Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.957 270.566L904.862 286.224L904.862 286.85L859.767 292.487L830.957 270.566ZM903.609 286.85L832.21 271.819L859.767 292.487L903.609 286.85Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.862 286.224L905.488 324.429L859.768 292.487L859.141 291.861L859.768 291.861L904.862 286.224ZM904.862 323.803L904.236 286.85L860.394 292.487L904.862 323.803Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.379 260.545L831.584 271.193L795.884 287.477L795.258 287.477L795.258 286.85L793.379 260.545ZM830.331 271.193L794.005 261.172L796.51 286.85L830.331 271.193Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.957 270.566L860.394 292.487L795.257 286.85L795.884 286.224L830.957 270.566ZM859.141 292.487L830.957 271.192L797.136 286.85L859.141 292.487Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.005 260.545L743.274 293.114L743.274 292.487L771.458 263.051L794.005 260.545ZM743.9 291.235L792.752 260.545L771.458 263.051L743.9 291.235Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.005 260.545L796.51 287.477L742.021 293.114L742.647 292.487L794.005 260.545ZM795.884 286.85L793.378 261.172L743.274 292.487L795.884 286.85Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.295 251.777L770.831 263.051L743.9 311.903L743.274 311.903L753.295 251.777ZM770.831 263.051L753.921 252.403L744.526 310.024L770.831 263.051Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.831 263.05L743.9 312.529L742.021 292.487L770.831 263.05ZM744.526 311.276L770.205 264.929L743.274 293.113L744.526 311.276Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 259.293L752.668 252.403L732 275.577L732 276.203L754.547 251.777L732 258.666L732 259.293Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 276.203L753.295 253.029L743.9 311.903L732 315.661L732 316.287L744.526 311.903L753.921 251.151L732 275.577L732 276.203Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.41 212.32L1131.59 220.462L1100.9 258.667L1108.41 212.32ZM1130.33 221.088L1108.41 213.572L1100.9 257.414L1130.33 221.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.04 212.319L1073.97 285.598L1026.37 220.461L1109.04 212.319ZM1073.34 284.971L1107.79 212.946L1026.37 220.461L1073.34 284.971Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.41 212.946L1101.52 258.666L1073.97 286.224L1073.34 286.224L1073.97 285.598L1108.41 212.946ZM1100.9 258.04L1107.79 214.198L1073.97 284.345L1100.9 258.04Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.04 208.562L1026.37 220.461L998.182 264.303L990.04 208.562ZM1025.74 221.088L990.04 209.188L997.556 263.677L1025.74 221.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.37 220.461L1073.97 286.224L997.556 264.303L1026.37 220.461ZM1072.71 284.971L1026.37 221.088L998.808 263.677L1072.71 284.971Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.04 208.561L949.956 250.524L949.33 250.524L967.493 221.714L990.04 208.561ZM951.209 248.645L988.788 209.814L968.119 221.714L951.209 248.645Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.666 208.562L998.808 264.303L949.956 250.524L990.666 208.562ZM998.182 263.677L990.04 209.188L949.956 249.898L998.182 263.677Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.493 221.714L928.662 291.234L928.035 291.234L933.046 256.787L967.493 221.714ZM929.288 289.355L966.867 222.966L933.672 256.787L929.288 289.355Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.493 221.714L928.662 291.234L928.035 291.234L949.33 250.524L967.493 221.714ZM935.551 278.082L961.856 231.109L949.956 250.524L935.551 278.082Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.457 237.998L933.672 256.161L904.236 286.85L904.236 286.224L890.457 237.998ZM933.046 256.787L891.083 239.251L904.862 286.224L933.046 256.787Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.672 255.535L928.662 290.608L904.236 286.224L933.672 255.535ZM928.662 290.608L933.046 257.414L905.488 286.851L928.662 290.608Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.557 208.562L891.083 238.625L830.957 271.193L830.331 271.819L830.331 271.193L878.557 208.562ZM890.457 238.625L878.557 209.814L831.584 270.566L890.457 238.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.083 237.998L905.488 286.85L830.957 271.193L830.957 270.566L891.083 237.998ZM904.236 286.224L890.457 238.624L831.584 270.566L904.236 286.224Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.557 208.561L794.005 260.545L794.005 259.919L782.731 234.866L878.557 208.561ZM794.005 260.545L877.304 209.814L782.731 236.119L794.005 260.545Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.557 208.562L830.957 271.193L793.379 260.545L878.557 208.562ZM830.957 270.566L877.931 209.814L794.631 260.545L830.957 270.566Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.105 235.493L786.489 248.645L770.831 263.051L770.205 263.051L770.205 262.424L782.105 235.493ZM785.863 248.645L782.105 236.745L771.458 262.424L785.863 248.645Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.105 235.493L794.005 261.172L770.832 263.677L770.205 263.677L770.205 263.05L782.105 235.493ZM793.379 260.545L782.105 236.745L771.458 263.05L793.379 260.545Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 234.867L785.237 248.645L753.921 251.777L732 240.503L732 241.13L753.295 252.403L786.489 248.645L732 234.867Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.115 248.645L770.831 263.677L753.295 253.029L752.668 253.029L753.295 253.029L787.115 248.645ZM770.831 263.05L785.236 249.272L753.921 252.403L770.831 263.05Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 241.13L753.294 252.403L732 258.666L732 259.293L754.547 252.403L732 240.503L732 241.13Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.31 175.367L1149.12 219.209L1149.12 219.835L1109.04 213.572L1058.31 175.367ZM1147.24 219.209L1060.19 177.246L1109.04 212.946L1147.24 219.209Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.31 175.367L1025.74 221.088L1015.72 186.014L1058.31 175.367ZM1026.37 219.835L1057.06 175.994L1016.35 186.641L1026.37 219.835Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.68 175.367L1109.04 212.946L1026.37 221.088L1057.68 175.367ZM1107.79 212.946L1057.68 175.994L1026.37 220.462L1107.79 212.946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.97 186.014L1013.84 204.177L990.666 209.188L990.666 208.562L1016.97 186.014ZM1013.21 203.551L1016.35 187.267L991.293 208.562L1013.21 203.551Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.35 186.014L1026.37 221.088L990.04 209.188L1016.35 186.014ZM1025.74 220.462L1016.35 187.267L990.666 209.188L1025.74 220.462Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.261 194.156L1013.84 203.551L966.867 221.714L976.261 194.156ZM1012.59 203.551L976.888 194.783L968.119 221.088L1012.59 203.551Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.21 203.551L967.493 221.714L967.493 221.088L990.04 208.562L1013.21 203.551ZM970.625 220.461L1010.71 204.804L990.667 209.188L970.625 220.461Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.046 169.73L976.887 194.156L933.672 256.161L933.672 255.535L933.046 169.73ZM976.261 194.783L933.672 170.983L933.672 256.161L976.261 194.783Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.261 194.783L968.119 221.714L933.672 256.787L933.672 257.414L933.672 256.787L976.261 194.783ZM967.493 221.714L975.635 196.035L934.925 254.282L967.493 221.714Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.046 170.356L920.52 206.682L891.083 238.624L890.457 238.624L933.046 170.356ZM920.52 206.682L932.419 172.235L892.336 236.119L920.52 206.682Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.672 169.73L933.672 256.787L890.457 238.624L933.672 169.73ZM933.046 256.161L933.046 170.983L891.083 237.998L933.046 256.161Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.846 194.783L920.519 206.682L920.519 207.309L878.557 209.814L837.846 194.783ZM918.014 206.682L839.725 195.409L878.557 209.188L918.014 206.682Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.146 206.683L891.083 239.251L878.557 209.188L921.146 206.683ZM891.083 237.998L919.893 207.309L879.183 209.814L891.083 237.998Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.22 194.783L782.105 236.746L781.479 237.372L782.105 236.119L795.257 214.825L837.22 194.783ZM783.357 234.867L835.968 195.409L795.884 214.198L783.357 234.867Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.847 194.783L879.809 209.188L782.105 236.119L782.105 235.493L837.847 194.783ZM877.93 209.188L837.847 195.409L783.984 236.119L877.93 209.188Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.921 189.146L795.257 214.198L786.489 248.646L753.921 189.146ZM794.631 214.825L755.173 190.399L786.489 248.019L794.631 214.825Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.631 214.825L786.489 248.645L786.489 249.272L782.105 236.119L794.631 214.825ZM786.489 248.019L794.631 216.704L782.731 236.746L786.489 248.019Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 194.783L753.921 190.398L732 209.814L732 210.44L755.174 189.772L732 194.156L732 194.783Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 210.44L754.547 190.399L785.863 248.019L732 234.867L787.115 249.272L754.547 189.772L732 209.814L732 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.72 137.162L1055.18 178.499L1055.18 177.872L1057.68 175.367L1134.72 137.162ZM1057.06 177.246L1094.63 157.83L1058.31 175.993L1057.06 177.246Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.17 147.81L1055.18 178.499L1015.72 187.267L1016.34 186.014L1050.17 147.81ZM1055.18 177.872L1050.17 149.062L1016.97 186.014L1055.18 177.872Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.68 175.367L1055.18 178.499L1015.72 187.267L1016.35 186.014L1057.68 175.367ZM1055.18 177.872L1057.06 175.994L1027.62 183.509L1055.18 177.872Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.17 148.436L1013.84 204.177L1013.21 204.177L1013.21 203.551L1015.72 168.478L1050.17 148.436ZM1013.84 202.925L1049.54 149.062L1016.35 168.478L1013.84 202.925Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.17 148.436L1013.84 204.177L1013.21 204.177L1013.21 203.551L1016.35 186.014L1050.17 148.436ZM1013.84 202.298L1048.29 150.941L1016.97 186.641L1013.84 202.298Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.72 168.478L976.261 195.409L954.967 179.125L1015.72 168.478ZM976.261 194.156L1014.47 168.478L955.593 178.499L976.261 194.156Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.35 167.851L1013.84 203.551L976.888 194.783L1016.35 167.851ZM1013.21 203.551L1015.72 169.104L976.888 194.783L1013.21 203.551Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.53 136.536L956.219 179.751L933.046 170.983L925.53 136.536ZM954.967 178.499L926.156 137.788L933.672 170.357L954.967 178.499Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.42 169.73L933.046 169.73L955.593 178.499L976.261 194.156L976.261 194.783L933.046 170.357L932.42 169.73ZM955.593 179.125L936.177 171.609L973.756 192.277L955.593 179.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.157 136.536L921.146 207.309L871.041 150.941L871.667 150.941L926.157 136.536ZM920.52 206.056L925.53 136.536L871.041 150.315L920.52 206.056Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.53 136.536L933.046 170.357L919.893 207.309L919.893 206.683L925.53 136.536ZM933.046 170.357L925.53 138.415L920.52 204.804L933.046 170.357Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.041 150.315L837.847 194.783L837.847 195.409L837.847 194.783L837.847 194.156L837.22 153.446L871.041 150.315ZM837.847 194.156L869.789 150.941L837.22 154.699L837.847 194.156Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.415 150.315L921.146 207.309L837.847 195.409L870.415 150.315ZM919.893 206.683L870.415 151.567L837.847 194.783L919.893 206.683Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.22 154.072L794.631 215.451L794.631 214.825L802.773 155.325L837.22 154.072ZM795.257 213.572L836.594 154.699L803.399 155.951L795.257 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.22 153.446L837.847 194.783L794.631 215.451L837.22 153.446ZM837.22 194.783L836.594 155.325L795.884 214.198L837.22 194.783Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.679 129.646L804.026 155.325L755.174 189.772L754.547 189.772L757.679 129.646ZM802.773 155.951L757.679 130.899L754.547 189.772L802.773 155.951Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.4 155.325L795.258 215.451L753.921 190.398L754.547 190.398L803.4 155.325ZM795.258 214.198L803.4 155.951L755.174 189.772L795.258 214.198Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 168.477L757.679 131.525L746.405 179.751L732 187.267L732 187.893L747.032 179.751L758.305 130.272L757.679 130.272L732 167.851L732 168.477Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 168.478L757.679 130.899L754.547 189.772L732 194.156L732 194.783L754.547 190.399L758.305 130.273L758.305 129.646L732 167.851L732 168.478Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 169.104L746.405 179.751L732 187.893L732 188.52L747.032 179.751L732 168.478L732 169.104Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 188.52L747.032 179.751L746.405 179.751L732 187.267L732 188.52Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.3 130.273L1054.55 178.499L1054.55 177.872L1095.89 130.899L1115.3 130.273ZM1057.06 175.993L1114.05 130.899L1096.51 132.152L1057.06 175.993Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.28 104.594L1115.93 130.899L1050.17 148.436L1043.28 104.594ZM1114.05 130.273L1043.9 105.22L1050.79 148.436L1114.05 130.273Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.68 130.273L1055.18 178.499L1050.17 148.436L1114.68 130.273ZM1055.18 177.872L1113.42 130.899L1050.17 148.436L1055.18 177.872Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.798 99.5833L1043.9 104.594L1016.35 169.104L1016.35 168.477L993.798 99.5833ZM1043.28 105.22L995.051 100.21L1016.35 167.851L1043.28 105.22Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.28 103.967L1050.17 148.436L1015.72 169.104L1015.72 168.477L1043.28 103.967ZM1050.17 148.436L1043.28 105.846L1016.35 167.851L1050.17 148.436Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.646 92.0675L994.424 99.5833L956.22 178.498L956.22 179.125L955.593 178.498L980.646 92.0675ZM993.798 99.5833L981.272 92.6938L956.846 175.993L993.798 99.5833Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.424 98.957L1016.35 168.477L955.593 179.125L994.424 98.957ZM1015.72 168.477L993.798 100.836L955.593 179.125L1015.72 168.477Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.015 88.3099L981.898 92.0677L981.272 92.694L925.53 137.162L918.015 88.3099ZM980.646 92.694L918.641 88.9362L925.53 135.909L980.646 92.694Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.272 92.0677L981.272 92.694L955.593 179.751L925.53 137.162L981.272 92.0677ZM955.593 178.499L980.645 93.3204L926.156 136.536L955.593 178.499Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.014 88.3098L870.415 150.941L870.415 150.315L870.415 124.01L918.014 88.3098ZM871.041 149.688L917.388 89.5624L871.667 124.01L871.041 149.688Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.641 88.3098L926.157 136.536L870.415 150.941L918.641 88.3098ZM925.53 136.536L918.014 89.5624L871.041 150.315L925.53 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.525 122.131L871.041 124.01L870.415 124.01L836.594 154.073L835.968 154.073L836.594 153.446L863.525 122.131ZM870.415 124.636L864.152 123.383L839.726 152.82L870.415 124.636Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.041 124.01L871.041 150.941L837.22 154.699L836.594 154.699L837.22 154.072L871.041 124.01ZM870.415 150.315L870.415 124.636L837.847 154.072L870.415 150.315Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.684 112.736L864.152 122.757L863.525 122.757L802.773 155.951L802.773 155.325L819.684 112.736ZM862.899 122.757L819.684 113.362L803.399 155.325L862.899 122.757Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.525 122.757L837.22 154.699L803.4 155.951L803.4 155.325L863.525 122.757ZM837.22 154.072L862.899 123.383L804.652 155.325L837.22 154.072Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.684 112.736L757.679 130.899L747.032 115.241L819.684 112.736ZM758.305 130.273L818.431 113.362L748.91 115.241L758.305 130.273Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.31 112.736L803.399 155.951L757.679 130.273L820.31 112.736ZM803.399 155.325L819.683 113.362L758.931 130.273L803.399 155.325Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 123.383L747.658 115.241L746.405 179.125L732 154.699L732 155.951L746.405 179.751L747.031 179.751L748.284 114.615L732 122.757L732 123.383Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.658 113.989L758.305 130.273L747.032 180.377L747.032 179.751L747.658 113.989ZM757.679 130.273L748.284 115.241L747.032 177.246L757.679 130.273Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 155.951L745.779 179.125L732 168.478L732 169.104L746.405 179.751L747.032 179.751L732 154.699L732 155.951Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.63 82.6731L1114.68 130.273L1114.05 130.273L1076.47 90.1888L1094.63 82.6731ZM1114.05 129.02L1094.63 83.2994L1078.35 90.8151L1114.05 129.02Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.72 90.8151L1068.33 95.1992L1043.28 105.22L1043.28 104.594L1077.72 90.8151Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.72 90.8153L1114.68 130.273L1114.68 130.899L1043.28 105.22L1077.72 90.8153ZM1114.05 129.647L1077.72 90.8153L1043.9 104.594L1114.05 129.647Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.94 92.6941L1067.7 94.573L1067.7 95.1993L993.798 99.5835L1001.94 92.6941ZM1062.69 95.1993L1001.94 93.3204L994.424 99.5835L1062.69 95.1993Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.33 94.573L1043.9 104.594L993.798 99.5835L994.424 98.9572L1068.33 94.573ZM1043.28 104.594L1066.45 95.1993L996.93 99.5835L1043.28 104.594Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.514 86.4309L1002.57 92.694L1002.57 93.3203L981.272 92.694L977.514 86.4309ZM1000.06 92.694L978.14 87.0572L981.272 92.0677L1000.06 92.694Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.646 92.694L1002.57 93.3203L993.798 100.21L980.646 92.694ZM1001.31 93.3203L981.898 92.694L993.798 98.9571L1001.31 93.3203Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.514 86.4308L908.62 97.7043L918.015 88.3097L977.514 86.4308ZM909.873 97.078L973.756 87.0571L918.015 88.936L909.873 97.078Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.14 86.431L981.898 92.6941L918.641 88.9362L918.641 88.3099L978.14 86.431ZM980.646 92.6941L977.514 87.0573L923.025 88.9362L980.646 92.6941Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.104 90.1888L909.873 97.0782L871.041 124.01L870.415 123.383L901.104 90.1888ZM909.246 97.0782L901.104 90.8151L872.294 122.757L909.246 97.0782Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.014 88.31L909.246 97.7046L870.415 124.636L870.415 124.01L918.014 88.31ZM881.062 116.494L909.246 97.0783L915.509 90.8152L881.062 116.494Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.02 77.6626L901.73 90.8151L864.151 123.383L864.151 122.757L861.02 77.6626ZM900.477 90.8151L861.02 78.2889L863.525 122.131L900.477 90.8151Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.104 90.1889L871.041 124.636L864.152 122.757L863.525 122.757L901.104 90.1889ZM870.415 124.01L897.972 93.3205L864.152 122.757L870.415 124.01Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.646 77.6625L819.684 113.989L819.684 113.362L804.652 86.4309L861.646 77.6625ZM819.684 112.736L859.768 78.2888L804.652 86.4309L819.684 112.736Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.02 77.0362L864.152 122.757L819.684 112.736L820.31 112.736L861.02 77.0362ZM863.525 122.131L861.02 78.2888L820.31 112.736L863.525 122.131Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.652 85.8047L747.658 114.615L747.658 113.989L779.6 86.431L804.652 85.8047ZM749.537 113.989L804.026 86.431L780.226 87.0573L749.537 113.989Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.278 85.8046L820.31 113.362L819.683 113.362L747.658 115.241L747.658 114.615L805.278 85.8046ZM819.683 112.736L805.278 86.4309L749.537 114.615L819.683 112.736Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 113.989L752.668 90.1887L778.973 87.6835L732 120.252L732 120.878L780.852 87.0572L752.042 89.5624L732 113.362L732 113.989Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 120.878L776.468 90.1888L747.658 114.615L732 122.757L732 123.383L748.284 115.241L780.226 87.0573L779.6 87.0573L732 120.252L732 120.878Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 87.6836L750.163 89.5626L732 92.6941L752.668 90.1889L752.668 89.5626L732 87.0573L732 87.6836Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 92.6939L752.042 90.1887L732 113.362L732 113.989L752.668 89.5624L732 92.6939Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.8 61.3786L1077.72 91.4415L1067.7 95.8257L1067.7 95.1994L1112.8 61.3786ZM1077.72 90.8152L1105.91 67.0154L1069.58 93.9468L1077.72 90.8152Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.478 42.589L963.109 59.4994L909.246 97.078L908.62 97.7043L908.62 97.078L900.478 42.589ZM962.483 60.1257L901.73 43.8416L909.873 97.078L962.483 60.1257Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.109 59.4994L978.14 87.0571L977.514 87.0571L908.62 97.7043L909.246 97.078L963.109 59.4994ZM977.514 86.4307L963.109 60.1257L910.498 97.078L977.514 86.4307Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.104 43.2153L909.873 97.7043L901.104 90.8149L901.104 43.2153ZM909.246 97.078L901.104 46.3469L901.104 90.8149L909.246 97.078Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.394 10.6472L879.183 40.0839L861.02 77.6625L860.394 78.2888L860.394 77.6625L860.394 10.6472ZM879.183 40.7102L861.02 12.5262L861.02 77.0362L879.183 40.7102Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.02 11.2735L901.73 90.8149L901.104 90.8149L861.646 78.2887L861.02 78.915L861.02 78.2887L861.02 11.2735ZM900.477 90.1886L861.02 12.5261L861.02 77.6624L900.477 90.1886Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.809 39.4577L861.02 77.6627L804.652 85.8047L804.652 85.1784L879.809 39.4577ZM861.02 77.6627L878.557 41.3367L805.905 85.8047L861.02 77.6627Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1420.45 377.145C1421.71 377.145 1422.34 376.517 1422.34 375.26C1422.34 374.003 1421.71 373.375 1420.45 373.375C1419.2 373.375 1418.57 374.003 1418.57 375.26C1418.57 376.517 1419.83 377.145 1420.45 377.145Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.54 377.774C1412.28 377.774 1411.66 378.402 1411.66 379.659C1411.66 380.916 1412.28 381.544 1413.54 381.544C1414.8 381.544 1415.43 380.916 1415.43 379.659C1415.43 378.402 1414.8 377.774 1413.54 377.774Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.07 367.09C1052.81 367.09 1052.19 368.347 1052.19 368.976C1052.19 370.232 1053.44 370.861 1054.07 370.861C1055.33 370.861 1055.96 369.604 1055.96 368.976C1055.96 368.347 1055.33 367.09 1054.07 367.09Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.9 328.127C1318.02 328.127 1316.76 329.384 1316.76 331.269C1316.76 333.154 1318.02 334.411 1319.9 334.411C1321.79 334.411 1323.05 333.154 1323.05 331.269C1323.05 329.384 1321.79 328.127 1319.9 328.127Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.73 341.324C1332.47 341.324 1331.84 341.953 1331.84 343.209C1331.84 344.466 1333.1 345.095 1333.73 345.095C1334.99 345.095 1335.61 344.466 1335.61 343.209C1335.61 341.953 1334.99 341.324 1333.73 341.324Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.87 372.746C1220.61 372.746 1219.98 373.375 1219.98 374.632C1219.98 375.888 1220.61 376.517 1221.87 376.517C1223.12 376.517 1223.75 375.888 1223.75 374.632C1223.75 373.375 1223.12 372.746 1221.87 372.746Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.93 291.677C1208.67 291.677 1208.04 292.934 1208.04 293.562C1208.04 294.819 1209.3 295.448 1209.93 295.448C1211.18 295.448 1211.81 294.191 1211.81 293.562C1212.44 292.934 1211.18 291.677 1209.93 291.677Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.24 362.063C1199.24 363.948 1200.5 365.205 1202.38 365.205C1204.27 365.205 1205.53 363.948 1205.53 362.063C1205.53 360.177 1204.27 358.92 1202.38 358.92C1200.5 358.92 1199.24 360.177 1199.24 362.063Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.45 330.64C1147.71 330.64 1148.97 329.383 1148.97 328.127C1148.97 326.87 1147.71 325.613 1146.45 325.613C1145.2 325.613 1143.94 326.87 1143.94 328.127C1143.94 329.383 1145.2 330.64 1146.45 330.64Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.83 333.783C1125.09 333.783 1126.34 332.526 1126.34 331.269C1126.34 330.012 1125.09 328.755 1123.83 328.755C1122.57 328.755 1121.32 330.012 1121.32 331.269C1121.32 332.526 1122.57 333.783 1123.83 333.783Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.5 335.04C1063.5 333.154 1061.61 331.269 1059.73 331.269C1057.84 331.269 1055.96 333.154 1055.96 335.04C1055.96 336.925 1057.84 338.81 1059.73 338.81C1061.61 338.182 1063.5 336.925 1063.5 335.04Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.91 303.617C1411.03 303.617 1409.77 304.874 1409.77 306.76C1409.77 308.645 1411.03 309.902 1412.91 309.902C1414.8 309.902 1416.06 308.645 1416.06 306.76C1416.68 305.503 1414.8 303.617 1412.91 303.617Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.52 260.255C1366.41 260.255 1367.67 258.998 1367.67 257.112C1367.67 255.227 1366.41 253.97 1364.52 253.97C1362.64 253.97 1361.38 255.227 1361.38 257.112C1361.38 258.998 1362.64 260.255 1364.52 260.255Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.01 297.961C1340.01 299.847 1341.27 301.104 1343.16 301.104C1345.04 301.104 1346.3 299.847 1346.3 297.961C1346.3 296.076 1345.04 294.819 1343.16 294.819C1341.27 294.819 1340.01 296.076 1340.01 297.961Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.84 338.182C1333.1 338.182 1333.73 336.925 1333.73 335.668C1333.73 334.411 1332.47 333.154 1331.22 333.154C1329.96 333.154 1328.83 333.336 1328.7 335.668C1328.57 338 1330.59 338.182 1331.84 338.182Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.03 302.989C1275.91 302.989 1277.17 301.732 1277.17 299.847C1277.17 297.961 1275.91 296.704 1274.03 296.704C1272.14 296.704 1270.88 297.961 1270.88 299.847C1270.88 301.103 1272.14 302.989 1274.03 302.989Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.04 270.31C1209.3 270.31 1210.55 269.053 1210.55 267.796C1210.55 266.539 1209.3 265.282 1208.04 265.282C1206.78 265.282 1205.53 266.539 1205.53 267.796C1205.53 269.053 1206.78 270.31 1208.04 270.31Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.39 315.558C1156.51 315.558 1154.62 316.815 1154.62 319.328C1154.62 321.214 1156.51 323.099 1158.39 323.099C1160.28 323.099 1162.16 321.842 1162.16 319.328C1161.54 316.815 1160.28 315.558 1158.39 315.558Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.51 302.989C1158.39 302.989 1159.65 301.732 1159.65 299.847C1159.65 297.961 1158.39 296.704 1156.51 296.704C1154.62 296.704 1153.37 297.961 1153.37 299.847C1153.37 301.732 1154.62 302.989 1156.51 302.989Z",
    fill: "#7F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.42 272.824C1186.67 272.824 1187.93 271.567 1187.93 270.31C1187.93 269.053 1186.67 267.796 1185.42 267.796C1184.16 267.796 1182.9 269.053 1182.9 270.31C1182.27 271.567 1183.53 272.824 1185.42 272.824Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.41 338.182C1091.15 338.182 1089.89 339.439 1089.89 340.695C1089.89 341.952 1091.15 343.209 1092.41 343.209C1093.66 343.209 1094.92 341.952 1094.92 340.695C1094.92 339.439 1093.66 338.182 1092.41 338.182Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.82 256.484C1166.56 256.484 1165.31 257.741 1165.31 258.998C1165.31 260.255 1166.56 261.511 1167.82 261.511C1169.08 261.511 1170.33 260.255 1170.33 258.998C1170.33 257.741 1169.08 256.484 1167.82 256.484Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.61 324.985C1081.72 324.985 1079.84 326.87 1079.84 328.755C1079.84 330.641 1081.72 332.526 1083.61 332.526C1085.49 332.526 1087.38 330.641 1087.38 328.755C1087.38 326.87 1085.49 324.985 1083.61 324.985Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.4 270.938C1410.4 272.824 1411.66 274.081 1413.54 274.081C1415.43 274.081 1416.68 272.824 1416.68 270.938C1416.68 269.053 1415.43 267.796 1413.54 267.796C1411.66 267.796 1410.4 269.053 1410.4 270.938Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.76 293.562C1316.76 294.819 1318.02 296.076 1319.28 296.076C1320.53 296.076 1321.79 294.819 1321.79 293.562C1321.79 292.305 1320.53 291.048 1319.28 291.048C1318.02 291.048 1316.76 292.305 1316.76 293.562Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.94 245.172C1302.94 246.429 1304.19 247.686 1305.45 247.686C1306.71 247.686 1307.96 246.429 1307.96 245.172C1307.96 243.915 1306.71 242.658 1305.45 242.658C1303.56 242.658 1302.94 243.915 1302.94 245.172Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.12 280.365C1246.38 280.365 1247.63 279.108 1247.63 277.851C1247.63 276.594 1246.38 275.337 1245.12 275.337C1243.86 275.337 1242.6 276.594 1242.6 277.851C1242.6 279.108 1243.86 280.365 1245.12 280.365Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.49 256.484C1084.24 256.484 1082.98 257.741 1082.98 258.998C1082.98 260.255 1084.24 261.511 1085.49 261.511C1086.75 261.511 1088.01 260.255 1088.01 258.998C1088.01 257.112 1086.75 256.484 1085.49 256.484Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.58 279.108C1100.58 280.993 1101.83 282.25 1103.72 282.25C1105.6 282.25 1106.86 280.993 1106.86 279.108C1106.86 277.223 1105.6 275.966 1103.72 275.966C1101.83 275.966 1100.58 277.223 1100.58 279.108Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.18 266.539C1350.07 266.539 1351.95 265.282 1351.95 262.769C1351.95 260.883 1350.7 258.998 1348.18 258.998C1346.3 258.998 1344.41 260.255 1344.41 262.769C1344.41 265.282 1346.3 266.539 1348.18 266.539Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.59 242.658C1193.59 244.543 1194.84 245.8 1196.73 245.8C1198.61 245.8 1199.87 244.543 1199.87 242.658C1199.87 240.773 1198.61 239.516 1196.73 239.516C1194.84 239.516 1193.59 241.401 1193.59 242.658Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.36 255.227C1197.36 257.112 1198.61 258.369 1200.5 258.369C1202.38 258.369 1203.64 257.112 1203.64 255.227C1203.64 253.342 1202.38 252.085 1200.5 252.085C1198.61 252.085 1197.36 253.97 1197.36 255.227Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.98 384.058C1059.73 384.058 1059.1 385.315 1059.1 385.944C1059.1 387 1060.07 387.829 1060.98 387.829C1062.58 387.829 1063.07 386.5 1063.07 385.944C1063.07 385.387 1062.24 384.058 1060.98 384.058Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.431 369.716C996.695 369.716 995.289 371.122 995.289 372.858C995.289 374.593 996.695 376 998.431 376C1000.17 376 1001.57 374.593 1001.57 372.858C1001.57 371.122 1000.17 369.716 998.431 369.716Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.69 376.517C963.576 376.517 964.833 375.26 964.833 373.375C964.833 371.489 963.576 370.232 961.69 370.232C959.805 370.232 958.548 371.489 958.548 373.375C958.548 375.26 959.805 376.517 961.69 376.517Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.66 305.503C1115.66 304.246 1114.4 302.989 1113.15 302.989C1111.89 302.989 1110.63 304.246 1110.63 305.503C1110.63 306.76 1111.89 308.016 1113.15 308.016C1114.4 308.645 1115.66 307.388 1115.66 305.503Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.4 318.072C1114.4 319.329 1115.66 319.957 1116.92 319.957C1118.17 319.957 1119.43 318.7 1119.43 318.072C1119.43 316.815 1118.17 316.186 1116.92 316.186C1115.66 315.558 1114.4 316.815 1114.4 318.072Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.21 340.067C1099.95 340.067 1098.69 341.324 1098.69 342.581C1098.69 343.838 1099.95 345.095 1101.21 345.095C1102.46 345.095 1103.72 343.838 1103.72 342.581C1103.72 341.324 1103.09 340.067 1101.21 340.067Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.85 325.613C1034.59 325.613 1033.33 326.87 1033.33 328.127C1033.33 329.383 1034.59 330.64 1035.85 330.64C1037.1 330.64 1038.36 329.383 1038.36 328.127C1038.36 326.87 1037.1 325.613 1035.85 325.613Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.39 363.319C1042.13 363.319 1040.87 364.576 1040.87 365.833C1040.87 367.09 1042.13 368.347 1043.39 368.347C1044.65 368.347 1045.9 367.09 1045.9 365.833C1045.9 364.576 1045.27 363.319 1043.39 363.319Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.007 361.434C949.75 361.434 948.493 362.691 948.493 363.948C948.493 365.205 949.75 366.462 951.007 366.462C952.264 366.462 953.521 365.205 953.521 363.948C953.521 362.691 952.264 361.434 951.007 361.434Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.17 368.347C1003.17 369.604 1004.42 370.861 1005.68 370.861C1006.94 370.861 1008.2 369.604 1008.2 368.347C1008.2 367.09 1006.94 365.833 1005.68 365.833C1003.8 365.833 1003.17 367.09 1003.17 368.347Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.328 334.411C917.071 334.411 916.442 335.04 916.442 336.297C916.442 337.553 917.699 338.182 918.328 338.182C919.585 338.182 920.213 337.553 920.213 336.297C920.213 335.04 919.585 334.411 918.328 334.411Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.841 355.15C783.841 357.035 785.098 358.292 786.983 358.292C788.868 358.292 790.125 357.035 790.125 355.15C790.125 353.264 788.868 352.007 786.983 352.007C785.098 352.007 783.841 353.264 783.841 355.15Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.465 363.948C804.382 363.948 802.694 365.636 802.694 367.719C802.694 369.801 804.382 371.489 806.465 371.489C808.547 371.489 810.235 369.801 810.235 367.719C810.235 365.636 808.547 363.948 806.465 363.948Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.992 309.273C741.735 309.273 740.478 310.53 740.478 311.787C740.478 313.044 741.735 314.301 742.992 314.301C744.249 314.301 745.506 313.044 745.506 311.787C745.506 310.53 744.249 309.273 742.992 309.273Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.92 291.677C1093.66 291.677 1092.41 292.934 1092.41 294.191C1092.41 295.447 1093.66 296.704 1094.92 296.704C1096.18 296.704 1097.43 295.447 1097.43 294.191C1097.43 292.934 1096.18 291.677 1094.92 291.677Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.22 291.677C1037.1 291.677 1038.36 290.42 1038.36 288.535C1038.36 286.649 1037.1 285.393 1035.22 285.393C1033.33 285.393 1032.08 286.649 1032.08 288.535C1032.08 290.42 1033.33 291.677 1035.22 291.677Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.741 264.025C993.741 265.911 995.627 267.796 997.512 267.796C999.397 267.796 1001.28 265.911 1001.28 264.025C1001.28 262.14 999.397 260.255 997.512 260.255C995.627 260.255 993.741 261.512 993.741 264.025Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.512 302.36C998.769 302.36 1000.03 301.103 1000.03 299.847C1000.03 298.59 998.769 297.333 997.512 297.333C996.255 297.333 994.998 298.59 994.998 299.847C994.998 301.103 996.255 302.36 997.512 302.36Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.442 331.269C917.699 331.269 919.585 330.012 919.585 328.755C919.585 327.498 918.328 326.241 916.442 326.241C915.186 326.241 913.3 327.498 913.3 328.755C913.3 330.012 914.557 331.269 916.442 331.269Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.121 253.97C951.007 253.97 952.892 252.085 952.892 250.2C952.892 248.314 951.007 246.429 949.121 246.429C947.236 246.429 945.351 248.314 945.351 250.2C945.351 252.085 947.236 253.97 949.121 253.97Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.502 322.471C903.245 322.471 902.617 323.099 902.617 324.356C902.617 325.613 903.245 326.241 904.502 326.241C905.759 326.241 906.387 325.613 906.387 324.356C906.387 323.099 905.131 322.471 904.502 322.471Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.754 287.278C925.869 287.278 924.612 288.535 924.612 290.42C924.612 292.305 925.869 293.562 927.754 293.562C929.64 293.562 930.897 292.305 930.897 290.42C930.897 289.163 929.64 287.278 927.754 287.278Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.36 286.649C901.36 287.906 902.617 289.163 903.874 289.163C905.131 289.163 906.387 287.906 906.387 286.649C906.387 285.392 905.131 284.136 903.874 284.136C902.617 284.136 901.36 285.392 901.36 286.649Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.625 295.448C860.511 295.448 861.768 294.191 861.768 292.305C861.768 290.42 860.511 289.163 858.625 289.163C856.74 289.163 855.483 290.42 855.483 292.305C855.483 294.191 856.74 295.448 858.625 295.448Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.754 287.278C790.754 289.163 792.639 291.049 794.524 291.049C796.41 291.049 798.295 289.163 798.295 287.278C798.295 285.393 796.41 283.507 794.524 283.507C792.639 283.507 790.754 284.764 790.754 287.278Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.639 263.397C794.524 263.397 795.781 262.14 795.781 260.255C795.781 258.369 794.524 257.113 792.639 257.113C790.754 257.113 789.497 258.369 789.497 260.255C789.497 262.14 790.754 263.397 792.639 263.397Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.106 295.448C742.363 295.448 743.62 294.191 743.62 292.934C743.62 291.677 742.363 290.42 741.106 290.42C739.85 290.42 738.593 291.677 738.593 292.934C738.593 294.191 739.85 295.448 741.106 295.448Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.419 248.314C750.336 248.314 748.648 250.002 748.648 252.085C748.648 254.167 750.336 255.855 752.419 255.855C754.501 255.855 756.189 254.167 756.189 252.085C756.189 250.002 754.501 248.314 752.419 248.314Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.93 288.535C1074.81 288.535 1076.07 287.278 1076.07 285.392C1076.07 283.507 1074.81 282.25 1072.93 282.25C1071.04 282.25 1069.78 283.507 1069.78 285.392C1069.78 287.278 1071.67 288.535 1072.93 288.535Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.69 257.741C1098.69 258.998 1099.95 259.626 1100.58 259.626C1101.83 259.626 1102.46 258.998 1102.46 257.741C1102.46 256.484 1101.21 255.856 1100.58 255.856C1099.95 255.856 1098.69 257.112 1098.69 257.741Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.717 273.452C830.974 273.452 832.231 272.195 832.231 270.938C832.231 269.681 830.974 268.424 829.717 268.424C828.46 268.424 827.204 269.681 827.204 270.938C827.204 272.195 828.46 273.452 829.717 273.452Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.387 265.282C770.644 265.282 771.9 264.025 771.9 262.768C771.9 261.512 770.644 260.255 769.387 260.255C768.13 260.255 766.873 261.512 766.873 262.768C766.873 264.025 768.13 265.282 769.387 265.282Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.153 258.998C933.41 258.998 934.667 257.741 934.667 256.484C934.667 255.227 933.41 253.97 932.153 253.97C930.897 253.97 929.64 255.227 929.64 256.484C929.64 257.741 930.897 258.998 932.153 258.998Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.955 248.314C781.955 250.199 783.212 251.456 785.098 251.456C786.983 251.456 788.24 250.199 788.24 248.314C788.24 246.429 786.983 245.172 785.098 245.172C783.212 245.172 781.955 246.429 781.955 248.314Z",
    fill: "#F26522"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.894 372.655L632.174 379.544L639.689 375.16L677.894 372.655ZM634.053 378.918L672.884 373.281L640.316 375.16L634.053 378.918Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07 331.318L273.924 370.15L280.187 335.076L344.07 331.318ZM274.55 368.897L343.444 331.945L280.813 335.076L274.55 368.897Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 350.734L678.521 372.655L670.378 296.245L703.573 303.134L669.752 295.619L677.894 372.655L678.521 373.281L703.573 351.36L703.573 350.734Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.894 372.655L678.521 373.281L703.573 362.634L679.147 372.029L703.573 351.36L703.573 350.734L677.894 372.655Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.752 295.619L671.005 335.077L640.315 375.16L639.689 375.16L669.752 295.619ZM670.378 335.077L669.752 296.872L640.942 373.908L670.378 335.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.752 295.619L678.52 373.281L639.689 375.786L669.752 295.619ZM677.894 372.655L669.752 296.871L640.316 375.16L677.894 372.655Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.479 331.319L551.379 335.703L553.885 343.845L539.479 331.319ZM550.753 335.703L540.732 331.945L553.258 342.592L550.753 335.703Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.875 293.74L494.385 299.377L494.385 300.003L441.775 375.16L429.875 293.74ZM493.132 300.003L429.875 294.366L441.775 373.908L493.132 300.003Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.502 293.74L422.36 362.634L421.733 362.008L376.013 299.377L430.502 293.74ZM422.36 361.381L429.875 294.366L377.265 300.003L422.36 361.381Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.501 294.366L442.401 375.16L422.359 362.008L430.501 294.366ZM441.775 373.908L430.501 296.245L422.986 362.008L441.775 373.908Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.639 299.377L378.517 318.792L365.991 328.813L376.639 299.377ZM377.891 318.792L376.639 300.629L367.244 326.934L377.891 318.792Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.639 299.377L422.359 362.008L421.733 362.634L365.991 328.813L376.639 299.377ZM421.733 361.381L377.265 300.629L367.244 328.187L421.733 361.381Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.517 318.792L344.697 331.945L312.755 341.339L312.755 340.713L378.517 318.792ZM325.907 336.329L344.697 330.692L364.112 323.803L325.907 336.329Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.517 318.792L367.244 328.187L344.697 331.319L344.697 330.692L378.517 318.792ZM366.618 327.561L377.265 319.419L346.576 330.692L366.618 327.561Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.987 328.813L313.381 340.713L280.187 335.076L280.187 334.45L303.987 328.813ZM312.129 340.087L303.987 329.44L281.44 335.076L312.129 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07 331.318L312.129 341.339L279.56 335.703L279.56 335.076L344.07 331.318ZM312.755 340.087L342.818 331.318L282.692 334.45L312.755 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 292.487L671.005 295.619L703.573 279.961L669.752 295.619L703.573 293.114L703.573 292.487Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 303.135L670.378 295.619L703.573 279.961L669.752 295.619L703.573 303.135Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 296.871L670.378 335.076L632.8 271.193L703.573 291.861L703.573 291.235L631.547 270.566L670.378 335.703L703.573 297.498L703.573 296.871Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 296.871L671.005 334.45L670.378 295.619L703.573 293.114L703.573 292.487L669.752 295.619L670.378 335.703L703.573 297.498L703.573 296.871Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.321 256.787L632.8 270.566L632.8 306.892L632.174 306.892L583.321 256.787ZM632.174 271.193L584.574 258.04L632.174 306.892L632.174 271.193Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.174 269.94L670.379 335.076L669.752 335.076L630.921 306.892L631.547 306.892L632.174 269.94ZM669.752 334.45L632.8 271.819L632.8 306.892L669.752 334.45Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.948 257.414L552.006 335.703L551.38 335.703L562.653 298.124L583.948 257.414ZM552.632 331.318L581.442 262.424L562.653 298.124L552.632 331.318Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.948 256.787L632.8 306.892L551.379 335.703L583.948 256.787ZM632.174 306.892L583.948 257.414L551.379 335.076L632.174 306.892Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.853 293.113L563.279 297.497L539.479 331.945L538.853 293.113ZM562.027 298.124L538.853 294.366L539.479 331.318L562.027 298.124Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.653 297.498L551.379 336.329L538.853 331.945L562.653 297.498ZM550.753 335.703L562.027 299.377L539.479 331.318L550.753 335.703Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.949 278.082L538.853 293.74L538.853 294.366L493.759 300.629L464.949 278.082ZM537.601 293.74L466.201 278.708L494.385 299.377L537.601 293.74Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.853 293.74L539.479 331.945L493.759 300.003L538.853 293.74ZM538.853 330.692L538.227 293.74L494.385 299.376L538.853 330.692Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.37 267.435L465.575 278.082L429.875 294.366L429.249 294.992L429.249 294.366L427.37 267.435ZM464.322 278.082L427.996 268.061L430.501 293.74L464.322 278.082Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.948 278.082L494.385 300.003L429.249 294.366L429.875 293.74L464.948 278.082ZM493.132 299.377L464.948 278.082L431.128 293.74L493.132 299.377Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.996 267.435L377.265 300.003L377.265 299.377L405.449 269.94L427.996 267.435ZM378.518 298.75L427.37 268.061L406.075 270.566L378.518 298.75Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.996 267.435L430.502 294.366L377.265 300.003L377.265 299.377L427.996 267.435ZM429.875 293.74L427.37 268.061L377.265 299.377L429.875 293.74Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.912 258.666L405.449 269.94L378.518 318.792L377.892 318.792L387.912 258.666ZM404.823 269.94L387.912 259.293L378.518 316.913L404.823 269.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.823 269.94L377.891 319.418L376.012 299.377L404.823 269.94ZM378.518 318.166L404.196 271.819L377.265 300.003L378.518 318.166Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.539 258.666L312.755 340.713L312.129 341.339L312.129 340.713L323.402 279.335L388.539 258.666ZM312.755 340.087L387.286 259.919L324.655 279.335L312.755 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.912 258.666L378.518 319.418L312.755 341.339L312.129 341.339L387.912 258.666ZM378.518 318.792L387.912 259.919L313.381 340.087L378.518 318.792Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.866 258.04L324.655 278.708L304.613 328.813L303.987 329.439L303.987 328.813L305.866 258.04ZM323.402 279.335L305.866 259.293L303.987 327.561L323.402 279.335Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.402 279.335L312.129 341.339L303.36 329.439L302.734 330.066L302.734 329.439L323.402 279.335ZM312.129 340.087L322.776 281.214L303.36 328.813L312.129 340.087Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 287.477L703.573 286.85L660.984 227.977L703.573 223.593L659.731 227.351L703.573 287.477Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.032 215.451L660.984 227.351L632.174 271.193L624.032 215.451ZM659.731 227.977L624.032 216.077L631.547 270.566L659.731 227.977Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 291.861L703.573 291.235L632.8 271.193L660.358 227.977L703.573 287.477L703.573 286.85L660.358 227.351L632.174 271.193L703.573 291.861Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.031 215.451L583.947 257.414L583.321 257.414L601.484 228.604L624.031 215.451ZM585.2 255.535L622.779 216.704L602.11 228.604L585.2 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.658 215.451L632.8 271.193L583.948 257.414L624.658 215.451ZM632.174 270.566L624.658 216.077L584.574 256.787L632.174 270.566Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.484 228.604L562.653 298.124L562.027 298.124L562.027 297.498L567.037 263.051L601.484 228.604ZM563.279 296.871L600.858 230.482L567.664 264.303L563.279 296.871Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.484 228.604L562.653 298.124L562.027 298.124L562.027 297.498L583.321 256.788L601.484 228.604ZM569.543 284.971L595.848 237.998L583.948 257.414L569.543 284.971Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.448 244.887L567.663 263.05L538.853 293.74L538.853 294.366L538.853 293.74L524.448 244.887ZM567.037 263.677L525.074 246.14L538.853 293.74L567.037 263.677Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.663 263.051L562.653 298.124L538.227 293.74L538.227 293.114L567.663 263.051ZM562.653 297.498L567.037 264.303L539.479 293.74L562.653 297.498Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.548 215.451L525.074 245.514L465.575 278.082L464.949 278.708L464.949 277.456L512.548 215.451ZM524.448 245.514L512.548 216.703L465.575 277.456L524.448 245.514Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.074 244.888L539.479 293.74L464.948 278.082L464.948 277.456L525.074 244.888ZM538.227 293.114L524.448 245.514L465.575 277.456L538.227 293.114Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.548 216.077L427.996 268.061L416.723 243.009L512.548 216.077ZM427.996 267.435L511.296 216.704L416.723 243.009L427.996 267.435Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.548 216.077L464.949 278.708L427.37 268.061L427.996 267.435L512.548 216.077ZM464.949 278.082L511.922 217.33L428.622 267.435L464.949 278.082Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.723 242.382L421.107 255.535L405.449 269.94L404.823 269.94L416.723 242.382ZM420.481 255.535L416.723 243.635L406.075 269.314L420.481 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.096 242.382L427.996 268.061L404.823 270.566L416.096 242.382ZM427.37 267.435L416.096 243.635L405.449 269.94L427.37 267.435Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.697 236.119L420.48 255.535L420.48 256.161L387.912 259.919L344.697 236.119ZM419.228 255.535L346.576 237.372L387.912 259.293L419.228 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.107 255.535L404.823 270.566L387.286 259.919L386.66 259.293L387.286 259.293L387.286 258.666L387.912 259.293L421.107 255.535ZM404.823 269.94L419.228 256.161L387.912 259.293L404.823 269.94Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.849 224.219L324.655 278.708L324.029 278.708L344.697 236.119L357.849 224.219ZM326.534 274.95L357.223 226.098L345.949 236.745L326.534 274.95Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.697 236.119L388.539 259.293L323.402 279.335L344.697 236.119ZM387.286 259.293L345.323 236.746L324.655 278.708L387.286 259.293Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.476 224.219L305.866 258.666L260.145 224.846L358.476 224.219ZM305.866 258.666L357.223 224.846L261.398 225.472L305.866 258.666Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.849 224.219L324.029 279.335L305.866 258.666L357.849 224.219ZM324.029 278.708L357.223 225.472L306.492 258.666L324.029 278.708Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 191.651L703.573 191.025L694.178 184.135L703.573 188.52L703.573 187.893L692.299 182.256L691.673 182.883L703.573 191.651Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.299 182.257L659.731 227.977L649.71 192.904L692.299 182.257ZM660.358 227.351L691.047 183.509L650.337 194.156L660.358 227.351Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.358 227.977L703.573 223.593L660.984 227.351L692.299 182.883L703.573 191.651L703.573 191.025L691.673 182.257L660.358 227.351L660.358 227.977Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.963 192.904L647.831 211.067L624.658 216.077L650.963 192.904ZM647.205 210.44L650.336 194.156L625.284 215.451L647.205 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.336 192.904L660.357 227.977L623.405 216.077L624.031 216.077L650.336 192.904ZM659.731 227.351L650.336 194.156L624.658 216.077L659.731 227.351Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.252 201.672L647.831 211.067L600.858 229.23L600.858 228.603L610.252 201.672ZM646.579 210.44L610.879 201.672L602.11 227.977L646.579 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.205 210.44L601.484 229.23L601.484 228.603L624.031 216.077L647.205 210.44ZM604.616 227.351L644.073 211.693L624.031 216.077L604.616 227.351Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.037 177.246L610.879 201.672L567.037 264.303L567.037 177.246ZM610.253 201.672L567.664 177.872L567.664 263.051L610.253 201.672Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.252 201.672L602.11 228.603L567.663 263.677L567.037 263.677L610.252 201.672ZM601.484 228.603L609.626 202.925L568.916 261.172L601.484 228.603Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.037 177.246L554.511 213.572L525.074 245.514L524.448 245.514L567.037 177.246ZM554.511 213.572L566.411 179.125L526.327 243.009L554.511 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.663 176.62L567.663 263.677L524.448 245.514L567.663 176.62ZM567.037 263.05L567.037 177.872L525.074 244.887L567.037 263.05Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.838 201.672L554.511 213.572L554.511 214.198L512.548 216.704L471.838 201.672ZM552.006 213.572L473.717 202.298L512.548 216.077L552.006 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.137 213.572L525.074 246.14L512.548 216.077L555.137 213.572ZM525.074 244.888L553.885 214.198L513.174 216.704L525.074 244.888Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.838 201.672L416.723 243.635L416.096 243.635L416.096 243.009L429.249 221.714L471.838 201.672ZM417.349 242.382L469.959 202.925L429.875 221.714L417.349 242.382Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.838 201.672L513.801 216.077L416.723 243.009L471.838 201.672ZM511.922 216.077L471.838 202.299L417.975 243.009L511.922 216.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.912 196.662L429.249 221.714L420.481 256.161L387.912 196.662ZM429.249 221.714L389.791 197.288L421.107 254.909L429.249 221.714Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.249 221.714L421.107 255.535L421.107 256.161L421.107 255.535L420.481 256.161L420.481 255.535L416.096 243.009L429.249 221.714ZM420.481 254.909L428.623 223.593L416.723 243.635L420.481 254.909Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.165 196.662L344.697 236.746L345.323 205.43L389.165 196.662ZM345.323 236.119L387.912 197.914L345.323 206.056L345.323 236.119Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.539 196.662L421.107 256.161L344.697 236.745L388.539 196.662ZM419.854 255.535L388.539 197.914L345.323 236.745L419.854 255.535Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.323 205.43L358.476 224.846L329.039 215.451L345.323 205.43ZM357.223 224.219L345.323 206.056L329.666 215.451L357.223 224.219Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.323 204.804L358.476 224.846L345.323 237.372L345.323 204.804ZM357.223 224.846L345.323 206.683L344.697 236.119L357.223 224.846Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.571 214.198L329.039 215.451L329.039 216.077L260.145 226.098L284.571 214.198ZM326.534 216.077L285.197 214.825L262.65 224.846L326.534 216.077Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.039 215.451L357.849 224.219L357.849 224.846L260.771 225.472L260.771 224.846L329.039 215.451ZM355.97 224.219L329.039 215.451L263.903 224.846L355.97 224.219Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.168 185.388L703.573 177.872L703.573 177.246L691.047 184.135L692.299 182.883L703.573 177.246L703.573 176.62L691.673 182.256L689.168 184.762L689.168 185.388Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.157 154.699L689.168 185.388L649.71 194.156L650.337 193.53L684.157 154.699ZM689.168 184.762L684.157 155.951L650.963 192.904L689.168 184.762Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.673 182.256L689.168 185.388L649.71 194.156L650.336 193.53L691.673 182.256ZM689.168 184.762L691.047 183.509L661.61 191.025L689.168 184.762Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.157 155.325L647.205 211.693L647.205 211.067L649.71 175.993L684.157 155.325ZM647.831 209.814L683.531 155.951L650.337 175.367L647.831 209.814Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.157 155.325L647.831 211.067L647.205 211.067L650.337 193.53L684.157 155.325ZM647.831 209.814L682.279 158.457L650.963 194.156L647.831 209.814Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.337 175.367L610.879 202.299L589.584 186.014L650.337 175.367ZM610.879 201.672L649.084 175.994L590.211 186.014L610.879 201.672Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.337 174.741L647.831 211.067L610.879 202.299L650.337 174.741ZM647.205 210.441L649.71 175.993L610.879 201.672L647.205 210.441Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.148 143.425L590.837 186.641L567.664 177.872L567.037 177.246L567.664 177.246L560.148 143.425ZM588.958 185.388L560.148 144.678L567.664 177.246L588.958 185.388Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.411 176.62L589.584 186.015L610.252 201.672L610.252 202.299L567.037 177.872L566.411 176.62ZM589.584 186.015L570.169 178.499L607.747 199.167L589.584 186.015Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.148 143.425L555.137 214.198L504.406 157.204L505.032 157.204L560.148 143.425ZM554.511 212.946L559.521 144.051L505.032 157.83L554.511 212.946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.148 143.425L567.663 177.246L554.511 213.572L553.885 213.572L560.148 143.425ZM567.037 177.246L559.521 145.304L554.511 212.319L567.037 177.246Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.032 157.204L471.838 201.672L471.838 202.299L471.838 201.672L471.838 201.046L471.212 160.336L505.032 157.204ZM471.838 201.046L504.406 157.831L471.838 161.588L471.838 201.046Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.406 157.204L555.137 214.198L471.838 202.298L504.406 157.204ZM553.885 213.572L504.406 158.457L471.838 201.672L553.885 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.838 160.962L429.875 221.714L429.249 221.714L437.391 162.215L471.838 160.962ZM429.875 221.088L471.212 162.215L438.017 163.467L429.875 221.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.212 160.962L471.838 201.672L428.623 222.34L471.212 160.962ZM471.212 201.672L470.585 162.214L429.875 221.088L471.212 201.672Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.67 137.162L438.017 162.841L389.165 197.288L388.538 197.288L391.67 137.162ZM436.764 162.841L391.67 137.788L388.538 196.662L436.764 162.841Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.017 162.215L429.875 222.34L388.538 197.288L389.165 197.288L438.017 162.215ZM429.249 221.714L437.391 163.467L389.165 197.288L429.249 221.714Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.67 137.162L381.023 186.641L345.323 205.43L345.323 204.804L391.67 137.162ZM380.397 186.641L391.044 138.415L345.95 204.804L380.397 186.641Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.296 136.536L389.165 197.288L345.323 206.056L392.296 136.536ZM388.539 196.662L391.67 137.789L345.949 204.804L388.539 196.662Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.645 140.294L381.023 186.641L380.397 186.641L329.039 215.451L319.645 140.294ZM380.397 186.641L320.271 141.546L329.665 215.451L380.397 186.641Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.397 186.641L329.039 216.077L329.039 215.451L345.323 205.43L380.397 186.641ZM337.808 210.44L361.607 197.288L345.323 206.056L337.808 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.271 140.294L284.571 214.825L283.945 214.825L297.723 154.699L320.271 140.294ZM285.197 212.946L319.018 142.173L297.723 155.325L285.197 212.946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.271 140.294L329.665 216.077L285.197 214.825L320.271 140.294ZM329.039 215.451L319.644 142.172L285.197 214.825L329.039 215.451Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 173.488L691.047 183.509L703.573 169.104L703.573 168.478L689.168 184.762L689.168 185.388L703.573 174.114L703.573 173.488Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 149.688L684.784 155.325L677.894 112.11L703.573 121.504L703.573 120.878L677.268 111.483L684.157 155.951L703.573 150.315L703.573 149.688Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.157 155.325L689.168 185.388L703.573 174.114L703.573 173.488L689.168 184.762L684.784 155.325L703.573 150.315L703.573 149.688L684.157 155.325Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.79 106.473L677.894 111.483L650.337 175.367L650.337 175.993L650.337 175.367L627.79 106.473ZM677.268 112.11L629.042 107.099L650.337 174.741L677.268 112.11Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.268 110.857L684.784 155.325L650.337 175.367L650.337 174.741L677.268 110.857ZM684.157 155.325L677.268 112.736L650.337 174.741L684.157 155.325Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.263 99.5835L628.416 106.473L590.211 186.014L589.584 186.014L615.263 99.5835ZM627.789 107.099L615.263 100.21L590.837 183.509L627.789 107.099Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.416 105.847L650.337 175.993L589.584 186.641L628.416 105.847ZM649.71 175.367L628.416 107.725L590.211 186.014L649.71 175.367Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.006 95.1993L615.889 99.5834L559.521 144.052L552.006 95.1993ZM614.637 99.5834L552.632 95.8256L560.148 142.799L614.637 99.5834Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.263 98.9571L589.585 186.641L559.522 144.051L615.263 98.9571ZM589.585 185.388L614.637 100.21L560.148 143.425L589.585 185.388Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.006 95.1992L504.406 157.83L504.406 157.204L504.406 130.899L552.006 95.1992ZM505.032 157.204L551.379 97.0781L505.659 131.525L505.032 157.204Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.632 95.1994L560.148 144.052L504.406 158.457L552.632 95.1994ZM559.521 143.425L552.006 96.452L505.032 157.204L559.521 143.425Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.517 129.646L505.032 131.525L471.212 162.215L470.585 161.588L497.517 129.646ZM504.406 131.525L498.143 130.273L473.717 159.709L504.406 131.525Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.032 130.899L505.032 157.83L470.585 161.588L505.032 130.899ZM504.406 157.83L504.406 132.152L471.838 160.962L504.406 157.83Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.675 119.625L498.769 129.646L498.143 129.646L437.391 162.841L437.391 162.215L453.675 119.625ZM497.517 129.646L454.301 120.252L438.017 162.215L497.517 129.646Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.516 129.646L471.211 161.588L437.391 162.841L437.391 162.215L497.516 129.646ZM471.211 160.962L496.89 130.273L438.643 162.215L471.211 160.962Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.301 119.625L392.297 137.788L382.276 122.131L454.301 119.625ZM392.297 137.162L452.422 120.252L382.902 122.131L392.297 137.162Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.301 119.625L437.391 162.841L391.67 137.162L454.301 119.625ZM437.391 162.215L453.675 120.252L392.923 137.162L437.391 162.215Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.276 121.504L381.023 186.641L351.586 137.162L382.276 121.504ZM380.397 186.014L381.649 122.131L351.586 137.788L380.397 186.014Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.649 120.878L392.296 137.162L381.023 187.267L380.397 186.641L381.649 120.878ZM391.67 137.162L382.275 122.131L381.023 184.136L391.67 137.162Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.239 107.725L351.586 138.415L319.018 141.546L305.239 107.725ZM350.96 137.788L306.492 108.978L320.271 140.92L350.96 137.788Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.586 137.788L381.023 186.641L380.397 186.641L319.018 140.294L319.644 140.294L351.586 137.788ZM379.77 186.014L350.96 138.415L320.271 141.546L379.77 186.014Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.866 108.352L310.876 137.162L297.724 155.325L297.097 155.325L305.866 108.352ZM310.25 136.536L305.866 109.605L297.724 154.073L310.25 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.866 107.099L320.271 140.92L297.097 155.325L305.866 107.099ZM319.644 140.92L305.866 108.978L297.723 154.073L319.644 140.92Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.268 112.11L702.32 102.089L703.573 101.463L703.573 100.836L677.268 111.484L677.268 112.11Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.573 121.504L703.573 120.878L677.894 111.483L703.573 101.462L703.573 100.836L677.268 111.483L677.268 112.11L703.573 121.504Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.931 100.21L702.32 102.089L702.32 102.715L628.416 107.099L635.931 100.21ZM697.31 102.089L636.558 100.21L629.042 106.473L697.31 102.089Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.32 102.089L677.894 112.11L627.789 107.099L628.416 106.473L702.32 102.089ZM677.268 111.483L700.441 102.089L630.921 106.473L677.268 111.483Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.505 93.3203L636.558 99.5834L636.558 100.21L615.263 99.5834L611.505 93.3203ZM634.052 99.5834L612.132 93.9466L615.263 98.9571L634.052 99.5834Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.637 99.5834L636.558 100.21L627.789 107.099L614.637 99.5834ZM635.305 100.21L615.889 99.5834L627.789 105.846L635.305 100.21Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.132 93.3204L543.238 104.594L552.632 95.1993L612.132 93.3204ZM544.49 103.968L608.374 93.9467L552.632 95.8256L544.49 103.968Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.132 93.3204L615.889 99.5835L552.632 95.8256L552.632 95.1993L612.132 93.3204ZM614.637 99.5835L611.505 93.9467L557.016 95.8256L614.637 99.5835Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.095 97.0781L543.864 104.594L505.032 131.525L505.032 130.899L535.095 97.0781ZM543.237 104.594L535.095 98.3307L506.285 130.273L543.237 104.594Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.006 95.1991L543.237 104.594L504.406 131.525L504.406 130.899L552.006 95.1991ZM515.68 124.009L543.864 104.594L550.127 98.3307L515.68 124.009Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.012 84.5521L535.722 97.7046L498.143 130.273L495.012 84.5521ZM534.469 97.7046L495.012 85.1784L497.517 129.02L534.469 97.7046Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.095 97.7044L505.032 131.525L498.143 129.646L535.095 97.7044ZM505.032 130.899L532.59 100.21L498.769 129.646L505.032 130.899Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.638 84.5522L453.675 120.878L453.675 120.252L438.643 93.3205L495.638 84.5522ZM454.301 119.626L494.385 85.1785L439.27 93.3205L454.301 119.626Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.638 84.5521L498.143 130.273L454.301 120.252L454.301 119.625L495.638 84.5521ZM497.517 129.646L495.012 85.8047L454.301 120.252L497.517 129.646Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 92.6941L382.275 121.504L381.649 121.504L381.649 120.878L413.591 93.3204L439.27 92.6941ZM383.528 120.878L438.017 93.3204L414.217 93.9467L383.528 120.878Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27 92.694L454.301 120.252L453.675 120.252L381.649 122.131L381.649 121.504L439.27 92.694ZM453.675 119.625L439.27 93.3203L383.528 121.504L453.675 119.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.844 93.9467L414.217 94.5731L351.586 138.415L350.96 137.788L386.034 96.452L414.844 93.9467ZM352.839 136.536L412.965 94.5731L386.66 97.0783L352.839 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.591 93.9466L381.649 122.131L350.96 137.788L350.96 137.162L413.591 93.9466ZM354.718 135.909L382.276 121.504L411.086 97.0781L354.718 135.909Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.607 93.9467L386.66 96.4519L386.66 97.0782L305.866 108.352L305.866 107.725L361.607 93.9467ZM384.781 97.0782L361.607 94.573L310.25 107.725L384.781 97.0782Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.286 96.4518L351.586 137.788L305.866 107.725L387.286 96.4518ZM351.586 137.788L386.033 97.7045L307.118 108.978L351.586 137.788Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.408 57.6207L362.234 93.9468L310.876 136.536L266.408 57.6207ZM360.981 93.9468L267.034 58.2471L310.25 135.91L360.981 93.9468Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.607 93.9466L310.25 137.162L305.866 107.725L361.607 93.9466ZM310.876 136.536L360.981 94.573L306.492 108.352L310.876 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.095 50.1049L597.726 67.0153L597.1 67.0153L543.237 104.594L543.237 103.968L535.095 50.1049ZM596.474 67.0153L535.722 50.7313L543.864 103.968L596.474 67.0153Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.1 66.389L612.132 93.9467L611.505 93.9467L543.864 104.594L543.864 103.968L597.1 66.389ZM611.505 93.3204L597.1 67.0153L544.49 103.968L611.505 93.3204Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.011 18.1631L535.095 50.105L535.095 97.7046L534.469 97.7046L495.011 18.1631ZM535.095 50.105L495.638 19.4157L535.095 96.452L535.095 50.105Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.095 50.1049L543.864 104.594L535.095 97.7046L535.095 50.1049ZM543.237 103.968L535.095 53.2365L535.095 97.7046L543.237 103.968Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.385 17.5367L513.174 46.9734L495.011 84.552L494.385 84.552L494.385 17.5367ZM513.174 47.5997L495.011 19.4157L495.011 83.9257L513.174 47.5997Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.012 18.163L535.722 98.3308L495.012 85.1783L495.012 18.163ZM534.469 97.0782L495.012 19.4156L495.012 84.552L534.469 97.0782Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.28 35.6996L513.801 46.9732L513.175 47.5995L438.644 93.9465L444.28 35.6996ZM512.548 47.5995L444.28 36.3259L438.644 92.6939L512.548 47.5995Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.801 46.9733L495.012 85.1783L438.644 93.3203L513.801 46.9733ZM495.012 84.552L512.548 48.226L439.896 92.694L495.012 84.552Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.907 35.6998L414.217 94.573L413.591 94.573L434.259 41.3366L444.907 35.6998ZM415.47 90.1888L443.654 36.3261L434.259 41.9629L415.47 90.1888Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.28 35.6998L439.27 93.3204L413.591 94.573L414.217 93.9467L444.28 35.6998ZM438.643 92.694L444.28 36.9524L414.217 93.9467L438.643 92.694Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.259 41.3365L414.217 93.9466L386.66 96.4519L386.033 96.4519L386.033 95.8256L434.259 41.3365ZM413.591 93.9466L433.007 42.5891L386.66 96.4519L413.591 93.9466Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.137 0.626556L521.943 33.821L494.385 19.4159L555.137 0.626556ZM521.943 32.5684L553.885 1.25286L495.011 18.7896L521.943 32.5684Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.137 -0.00012207L535.095 50.1047L494.385 18.1629L555.137 -0.00012207ZM535.095 50.1047L554.511 1.2525L495.011 18.7892L535.095 50.1047Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.385 18.1631L522.569 33.1946L513.801 48.2261L494.385 18.1631ZM521.943 33.1946L495.638 19.4158L513.174 46.9734L521.943 33.1946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.017 5.01065L444.28 36.3262L434.259 41.9631L434.259 42.5894L434.259 41.9631L434.259 41.3368L438.017 5.01065ZM444.28 35.6999L438.017 6.26328L434.259 41.3368L444.28 35.6999Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.523 341.966L281.439 386.434L263.903 365.766L321.523 341.966ZM281.439 385.808L320.897 343.218L264.529 366.392L281.439 385.808Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.903 365.765L218.182 372.655L225.698 368.271L263.903 365.765ZM219.435 372.028L258.892 366.392L226.324 368.271L219.435 372.028Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.903 365.766L282.066 386.434L218.182 372.655L218.808 372.029L263.903 365.766ZM280.813 385.808L263.903 366.392L220.061 372.655L280.813 385.808Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.209 363.886L226.324 368.271L226.324 368.897L182.482 373.907L171.209 363.886ZM223.193 368.271L171.835 364.513L181.856 373.281L223.193 368.271Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.698 368.271L218.182 373.281L181.856 373.907L181.23 373.907L181.23 373.281L225.698 368.271ZM218.808 372.029L225.072 368.271L187.493 372.655L218.808 372.029Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.423 305.013L337.181 318.166L322.15 342.592L321.523 342.592L333.423 305.013ZM336.555 317.54L333.423 306.266L322.776 340.713L336.555 317.54Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.761 288.103L334.05 305.64L264.529 366.392L255.761 288.103ZM332.797 305.64L255.761 288.729L264.529 365.139L332.797 305.64Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.05 305.013L322.15 342.592L264.529 365.766L334.05 305.013ZM321.523 341.966L332.797 306.266L265.155 365.139L321.523 341.966Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.761 288.729L257.013 328.187L226.324 368.271L225.698 368.271L225.698 367.644L255.761 288.729ZM256.387 328.187L255.761 289.982L226.951 367.018L256.387 328.187Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.761 288.729L264.529 366.392L225.698 368.897L225.698 368.271L255.761 288.729ZM263.903 365.766L255.761 289.982L226.324 367.645L263.903 365.766Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.182 300.003L257.013 328.187L171.835 364.513L171.835 363.887L218.182 300.003ZM255.761 328.187L218.182 300.629L172.462 363.887L255.761 328.187Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.013 327.561L225.698 368.271L171.835 363.887L171.835 363.26L172.462 363.26L257.013 327.561ZM225.698 367.644L255.761 328.187L173.088 363.26L225.698 367.644Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.488 324.429L137.388 328.813L139.893 336.955L125.488 324.429ZM136.762 328.813L126.114 325.055L138.641 335.703L136.762 328.813Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8837 286.85L80.3937 292.487L28.4099 367.645L15.8837 286.85ZM79.1411 293.114L15.8837 287.477L27.7836 367.018L79.1411 293.114Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5099 286.85L8.36783 355.745L7.74153 355.118L-37.9792 292.487L16.5099 286.85ZM8.36783 354.492L15.8835 287.477L-36.7265 293.114L8.36783 354.492Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 286.85L27.7833 367.645L7.74146 354.492L16.5098 286.85ZM27.157 367.018L15.8835 289.356L8.36776 354.492L27.157 367.018Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.3527 291.861L8.36798 354.492L8.36798 355.118L-47.3737 321.297L-37.3527 291.861ZM7.11538 353.866L-37.3527 293.113L-47.3737 320.671L7.11538 353.866Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.523 258.04L334.05 306.266L315.26 294.366L321.523 258.04ZM332.797 305.013L320.897 259.293L315.26 293.74L332.797 305.013Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.897 258.04L293.339 286.224L255.761 289.356L255.761 288.729L320.897 258.04ZM293.339 285.598L319.645 259.293L257.013 288.729L293.339 285.598Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.523 258.04L334.05 306.266L333.423 306.266L255.761 289.356L321.523 258.04ZM332.797 305.64L320.897 258.666L256.387 288.729L332.797 305.64Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.556 263.677L293.966 285.598L256.387 328.813L217.556 263.677ZM293.339 285.598L218.808 264.303L256.387 327.561L293.339 285.598Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.966 285.598L255.761 328.813L255.134 288.729L293.966 285.598ZM256.387 327.561L292.713 286.224L255.761 289.356L256.387 327.561Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33 249.898L218.808 263.677L218.808 300.003L218.182 300.003L169.33 249.898ZM218.182 264.303L170.582 251.151L218.182 300.003L218.182 264.303Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.182 263.051L256.387 328.187L255.761 328.187L216.929 300.003L217.556 300.003L218.182 263.051ZM255.761 326.934L218.808 264.303L218.808 299.377L255.761 326.934Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33 250.524L137.388 328.813L136.762 329.439L136.762 328.813L148.035 291.234L169.33 250.524ZM138.641 324.429L167.451 255.535L148.662 291.234L138.641 324.429Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.956 249.898L218.808 300.003L218.182 300.003L136.761 328.813L136.135 329.439L136.761 328.813L169.956 249.898ZM217.556 300.003L169.33 250.524L136.761 328.187L217.556 300.003Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.236 286.224L148.662 290.608L124.862 325.055L124.862 324.429L124.236 286.224ZM148.035 291.235L124.862 287.477L125.488 323.803L148.035 291.235Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.662 290.608L137.388 328.813L124.862 324.429L148.662 290.608ZM136.762 328.187L148.035 292.487L125.488 324.429L136.762 328.187Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.957 270.566L124.862 286.224L124.862 286.85L79.7672 292.487L50.957 270.566ZM123.609 286.85L52.2096 271.819L79.7672 292.487L123.609 286.85Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.862 286.224L125.488 324.429L79.7675 292.487L79.1412 291.861L79.7675 291.861L124.862 286.224ZM124.862 323.803L124.236 286.85L80.3938 292.487L124.862 323.803Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3786 260.545L51.5836 271.193L15.8838 287.477L15.2575 287.477L15.2575 286.85L13.3786 260.545ZM50.3309 271.193L14.0049 261.172L16.5102 286.85L50.3309 271.193Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9571 270.566L80.3937 292.487L15.2573 286.85L15.8836 286.224L50.9571 270.566ZM79.1411 292.487L50.9571 271.192L17.1363 286.85L79.1411 292.487Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.005 260.545L-36.7262 293.114L-36.7262 292.487L-8.54219 263.051L14.005 260.545ZM-36.0999 291.235L12.7524 260.545L-8.54219 263.051L-36.0999 291.235Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0046 260.545L16.5099 287.477L-37.9792 293.114L-37.3529 292.487L14.0046 260.545ZM15.8835 286.85L13.3783 261.172L-36.7265 292.487L15.8835 286.85Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.413 212.32L351.586 220.462L320.897 258.667L328.413 212.32ZM350.334 221.088L328.413 213.572L320.897 257.414L350.334 221.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.039 212.319L293.966 285.598L246.366 220.461L329.039 212.319ZM293.339 284.971L327.787 212.946L246.366 220.461L293.339 284.971Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.413 212.946L321.523 258.666L293.966 286.224L293.339 286.224L293.966 285.598L328.413 212.946ZM320.897 258.04L327.786 214.198L293.966 284.345L320.897 258.04Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.04 208.562L246.366 220.461L218.182 264.303L210.04 208.562ZM245.74 221.088L210.04 209.188L217.556 263.677L245.74 221.088Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.366 220.461L293.966 286.224L217.556 264.303L246.366 220.461ZM292.713 284.971L246.366 221.088L218.808 263.677L292.713 284.971Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.04 208.561L169.956 250.524L169.33 250.524L187.493 221.714L210.04 208.561ZM171.209 248.645L208.788 209.814L188.119 221.714L171.209 248.645Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.666 208.562L218.808 264.303L169.956 250.524L210.666 208.562ZM218.182 263.677L210.04 209.188L169.956 249.898L218.182 263.677Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.493 221.714L148.661 291.234L148.035 291.234L153.046 256.787L187.493 221.714ZM149.288 289.355L186.866 222.966L153.672 256.787L149.288 289.355Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.493 221.714L148.661 291.234L148.035 291.234L169.33 250.524L187.493 221.714ZM155.551 278.082L181.856 231.109L169.956 250.524L155.551 278.082Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.457 237.998L153.672 256.161L124.235 286.85L124.235 286.224L110.457 237.998ZM153.046 256.787L111.083 239.251L124.862 286.224L153.046 256.787Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.672 255.535L148.662 290.608L124.235 286.224L153.672 255.535ZM148.662 290.608L153.046 257.414L125.488 286.851L148.662 290.608Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.557 208.562L111.083 238.625L50.9573 271.193L50.331 271.819L50.331 271.193L98.557 208.562ZM110.457 238.625L98.557 209.814L51.5836 270.566L110.457 238.625Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.083 237.998L125.488 286.85L50.9572 271.193L50.9572 270.566L111.083 237.998ZM124.236 286.224L110.457 238.624L51.5835 270.566L124.236 286.224Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5568 208.561L14.0049 260.545L14.0049 259.919L2.73133 234.866L98.5568 208.561ZM14.0049 260.545L97.3042 209.814L2.73133 236.119L14.0049 260.545Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5568 208.562L50.9572 271.193L13.3786 260.545L98.5568 208.562ZM50.9572 270.566L97.9305 209.814L14.6312 260.545L50.9572 270.566Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10492 235.493L6.48908 248.645L-9.16868 263.051L-9.79498 263.051L-9.79498 262.424L2.10492 235.493ZM5.86278 248.645L2.10492 236.745L-8.54233 262.424L5.86278 248.645Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10507 235.493L14.005 261.172L-9.16856 263.677L-9.79486 263.677L-9.79486 263.05L2.10507 235.493ZM13.3787 260.545L2.10507 236.745L-8.54221 263.05L13.3787 260.545Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.9999 234.867L5.23647 248.645L-26.0791 251.777L-47.9999 240.503L-47.9999 241.13L-26.7054 252.403L6.48908 248.645L-47.9999 234.867Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11524 248.645L-9.16885 263.677L-26.7055 253.029L-27.3318 253.029L-26.7055 253.029L7.11524 248.645ZM-9.16885 263.05L5.23629 249.272L-26.0792 252.403L-9.16885 263.05Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.308 175.367L369.123 219.209L369.123 219.835L329.039 213.572L278.308 175.367ZM367.244 219.209L280.187 177.246L329.039 212.946L367.244 219.209Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.308 175.367L245.74 221.088L235.719 186.014L278.308 175.367ZM246.366 219.835L277.055 175.994L236.345 186.641L246.366 219.835Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.682 175.367L329.039 212.946L246.366 221.088L277.682 175.367ZM327.786 212.946L277.682 175.994L246.366 220.462L327.786 212.946Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.971 186.014L233.84 204.177L210.666 209.188L210.666 208.562L236.971 186.014ZM233.214 203.551L236.345 187.267L211.293 208.562L233.214 203.551Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.345 186.014L246.366 221.088L210.04 209.188L236.345 186.014ZM245.74 220.462L236.345 187.267L210.666 209.188L245.74 220.462Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.261 194.156L233.84 203.551L186.867 221.714L196.261 194.156ZM232.587 203.551L196.887 194.783L188.119 221.088L232.587 203.551Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.214 203.551L187.493 221.714L187.493 221.088L210.04 208.562L233.214 203.551ZM190.625 220.461L230.708 204.804L210.667 209.188L190.625 220.461Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.045 169.73L196.887 194.156L153.672 256.161L153.672 255.535L153.045 169.73ZM196.261 194.783L153.672 170.983L153.672 256.161L196.261 194.783Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.261 194.783L188.119 221.714L153.672 256.787L153.672 257.414L153.672 256.787L196.261 194.783ZM187.493 221.714L195.635 196.035L154.925 254.282L187.493 221.714Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.046 170.356L140.519 206.682L111.083 238.624L110.457 238.624L153.046 170.356ZM140.519 206.682L152.419 172.235L112.335 236.119L140.519 206.682Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.672 169.73L153.672 256.787L110.457 238.624L153.672 169.73ZM153.046 256.161L153.046 170.983L111.083 237.998L153.046 256.161Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8463 194.783L140.519 206.682L140.519 207.309L98.5565 209.814L57.8463 194.783ZM138.014 206.682L59.7252 195.409L98.5565 209.188L138.014 206.682Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.146 206.683L111.083 239.251L98.5568 209.188L141.146 206.683ZM111.083 237.998L139.893 207.309L99.1831 209.814L111.083 237.998Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2202 194.783L2.10476 236.746L1.47845 237.372L2.10476 236.119L15.2573 214.825L57.2202 194.783ZM3.35736 234.867L55.9675 195.409L15.8836 214.198L3.35736 234.867Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8465 194.783L99.8093 209.188L2.1048 236.119L2.1048 235.493L57.8465 194.783ZM97.9304 209.188L57.8465 195.409L3.98375 236.119L97.9304 209.188Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.0792 189.146L15.2573 214.198L6.48891 248.646L-26.0792 189.146ZM14.631 214.825L-24.8266 190.399L6.48891 248.019L14.631 214.825Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.631 214.825L6.489 248.645L6.489 249.272L2.10486 236.119L14.631 214.825ZM6.489 248.019L14.631 216.704L2.73116 236.746L6.489 248.019Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.0001 210.44L-25.4529 190.399L5.86258 248.019L-48.0001 234.867L7.11523 249.272L-25.4529 189.772L-48.0001 209.814L-48.0001 210.44Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.718 137.162L275.176 178.499L275.176 177.872L277.682 175.367L354.718 137.162ZM277.055 177.246L314.634 157.83L278.308 175.993L277.055 177.246Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.166 147.81L275.176 178.499L235.719 187.267L236.345 186.014L270.166 147.81ZM275.176 177.872L270.166 149.062L236.971 186.014L275.176 177.872Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.682 175.367L275.176 178.499L235.719 187.267L236.345 186.014L277.682 175.367ZM275.176 177.872L277.055 175.994L247.619 183.509L275.176 177.872Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.166 148.436L233.84 204.177L233.213 204.177L233.213 203.551L235.719 168.478L270.166 148.436ZM233.84 202.925L269.539 149.062L236.345 168.478L233.84 202.925Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.166 148.436L233.84 204.177L233.213 204.177L233.213 203.551L236.345 186.014L270.166 148.436ZM233.84 202.298L268.287 150.941L236.971 186.641L233.84 202.298Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.719 168.478L196.261 195.409L174.967 179.125L235.719 168.478ZM196.261 194.156L234.466 168.478L175.593 178.499L196.261 194.156Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.345 167.851L233.84 203.551L196.888 194.783L236.345 167.851ZM233.214 203.551L235.719 169.104L196.888 194.783L233.214 203.551Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53 136.536L176.219 179.751L153.046 170.983L145.53 136.536ZM174.966 178.499L146.156 137.788L153.672 170.357L174.966 178.499Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42 169.73L153.046 169.73L175.593 178.499L196.261 194.156L196.261 194.783L153.046 170.357L152.42 169.73ZM175.593 179.125L156.177 171.609L193.756 192.277L175.593 179.125Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.156 136.536L141.146 207.309L91.041 150.941L91.6674 150.941L146.156 136.536ZM140.52 206.056L145.53 136.536L91.041 150.315L140.52 206.056Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53 136.536L153.046 170.357L139.893 207.309L139.893 206.683L145.53 136.536ZM153.046 170.357L145.53 138.415L140.519 204.804L153.046 170.357Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0411 150.315L57.8467 194.783L57.8467 195.409L57.8467 194.783L57.8467 194.156L57.2204 153.446L91.0411 150.315ZM57.8467 194.156L89.7885 150.941L57.2204 154.699L57.8467 194.156Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4148 150.315L141.146 207.309L57.8466 195.409L90.4148 150.315ZM139.893 206.683L90.4148 151.567L57.8466 194.783L139.893 206.683Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2202 154.072L14.631 215.451L14.631 214.825L22.7731 155.325L57.2202 154.072ZM15.2573 213.572L56.5938 154.699L23.3994 155.951L15.2573 213.572Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2204 153.446L57.8467 194.783L14.6312 215.451L57.2204 153.446ZM57.2204 194.783L56.594 155.325L15.8838 214.198L57.2204 194.783Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.3213 129.646L24.0258 155.325L-24.8265 189.772L-25.4528 189.772L-22.3213 129.646ZM22.7732 155.951L-22.3213 130.899L-25.4528 189.772L22.7732 155.951Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3997 155.325L15.2576 215.451L-26.079 190.398L-25.4527 190.398L23.3997 155.325ZM15.2576 214.198L23.3997 155.951L-24.8264 189.772L15.2576 214.198Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.302 130.273L274.55 178.499L274.55 177.872L315.887 130.899L335.302 130.273ZM277.055 175.993L334.05 130.899L316.513 132.152L277.055 175.993Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.276 104.594L335.928 130.899L270.166 148.436L263.276 104.594ZM334.05 130.273L263.903 105.22L270.792 148.436L334.05 130.273Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.676 130.273L275.176 178.499L270.166 148.436L334.676 130.273ZM275.176 177.872L333.423 130.899L270.166 148.436L275.176 177.872Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.798 99.5833L263.903 104.594L236.345 169.104L236.345 168.477L213.798 99.5833ZM263.276 105.22L215.05 100.21L236.345 167.851L263.276 105.22Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.276 103.967L270.166 148.436L235.719 169.104L235.719 168.477L263.276 103.967ZM270.166 148.436L263.276 105.846L236.345 167.851L270.166 148.436Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.646 92.0675L214.424 99.5833L176.219 178.498L176.219 179.125L175.593 178.498L200.646 92.0675ZM213.798 99.5833L201.272 92.6938L176.846 175.993L213.798 99.5833Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.424 98.957L236.345 168.477L175.593 179.125L214.424 98.957ZM235.719 168.477L213.798 100.836L175.593 179.125L235.719 168.477Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.015 88.3099L201.898 92.0677L201.272 92.694L145.53 137.162L138.015 88.3099ZM200.646 92.694L138.641 88.9362L145.53 135.909L200.646 92.694Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.272 92.0677L201.272 92.694L175.593 179.751L145.53 137.162L201.272 92.0677ZM175.593 178.499L200.645 93.3204L146.156 136.536L175.593 178.499Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.014 88.3098L90.4147 150.941L90.4147 150.315L90.4147 124.01L138.014 88.3098ZM91.041 149.688L137.388 89.5624L91.6674 124.01L91.041 149.688Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.641 88.3098L146.156 136.536L90.4147 150.941L138.641 88.3098ZM145.53 136.536L138.014 89.5624L91.041 150.315L145.53 136.536Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5254 122.131L91.0411 124.01L90.4148 124.01L56.594 154.073L55.9677 154.073L56.594 153.446L83.5254 122.131ZM90.4148 124.636L84.1517 123.383L59.7256 152.82L90.4148 124.636Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0411 124.01L91.0411 150.941L57.2203 154.699L56.594 154.699L57.2203 154.072L91.0411 124.01ZM90.4148 150.315L90.4148 124.636L57.8466 154.072L90.4148 150.315Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6834 112.736L84.1514 122.757L83.5251 122.757L22.7731 155.951L22.7731 155.325L39.6834 112.736ZM82.8988 122.757L39.6834 113.362L23.3994 155.325L82.8988 122.757Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5253 122.757L57.2202 154.699L23.3995 155.951L23.3995 155.325L83.5253 122.757ZM57.2202 154.072L82.899 123.383L24.6521 155.325L57.2202 154.072Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6835 112.736L-22.3213 130.899L-32.9686 115.241L39.6835 112.736ZM-21.695 130.273L38.4309 113.362L-31.0897 115.241L-21.695 130.273Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3097 112.736L23.3993 155.951L-22.3214 130.273L40.3097 112.736ZM23.3993 155.325L39.6834 113.362L-21.0688 130.273L23.3993 155.325Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.634 82.6731L334.676 130.273L334.05 130.273L296.471 90.1888L314.634 82.6731ZM334.05 129.02L314.634 83.2994L298.35 90.8151L334.05 129.02Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.724 90.8151L288.329 95.1992L263.277 105.22L263.277 104.594L297.724 90.8151Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.723 90.8153L334.676 130.273L334.676 130.899L263.276 105.22L297.723 90.8153ZM334.05 129.647L297.723 90.8153L263.903 104.594L334.05 129.647Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94 92.6941L287.703 94.573L287.703 95.1993L213.798 99.5835L221.94 92.6941ZM282.692 95.1993L221.94 93.3204L214.424 99.5835L282.692 95.1993Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.329 94.573L263.903 104.594L213.798 99.5835L214.424 98.9572L288.329 94.573ZM263.277 104.594L286.45 95.1993L216.93 99.5835L263.277 104.594Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.514 86.4309L222.566 92.694L222.566 93.3203L201.272 92.694L197.514 86.4309ZM220.061 92.694L198.14 87.0572L201.272 92.0677L220.061 92.694Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.646 92.694L222.566 93.3203L213.798 100.21L200.646 92.694ZM221.314 93.3203L201.898 92.694L213.798 98.9571L221.314 93.3203Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.514 86.4308L128.62 97.7043L138.015 88.3097L197.514 86.4308ZM129.872 97.078L193.756 87.0571L138.015 88.936L129.872 97.078Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14 86.431L201.898 92.6941L138.641 88.9362L138.641 88.3099L198.14 86.431ZM200.646 92.6941L197.514 87.0573L143.025 88.9362L200.646 92.6941Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.104 90.1888L129.873 97.0782L91.0412 124.01L90.4149 123.383L121.104 90.1888ZM129.246 97.0782L121.104 90.8151L92.2939 122.757L129.246 97.0782Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.014 88.31L129.246 97.7046L90.4147 124.636L90.4147 124.01L138.014 88.31ZM101.062 116.494L129.246 97.0783L135.509 90.8152L101.062 116.494Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0198 77.6626L121.73 90.8151L84.1514 123.383L84.1514 122.757L81.0198 77.6626ZM120.477 90.8151L81.0198 78.2889L83.5251 122.131L120.477 90.8151Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.104 90.1889L91.0409 124.636L84.1515 122.757L83.5252 122.757L121.104 90.1889ZM90.4146 124.01L117.972 93.3205L84.1515 122.757L90.4146 124.01Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6464 77.6625L39.6836 113.989L39.6836 113.362L24.6521 86.4309L81.6464 77.6625ZM39.6836 112.736L79.7675 78.2888L24.6521 86.4309L39.6836 112.736Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0199 77.0362L84.1514 122.757L39.6834 112.736L40.3097 112.736L81.0199 77.0362ZM83.5251 122.131L81.0199 78.2888L40.3097 112.736L83.5251 122.131Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.652 85.8047L-32.3423 114.615L-32.3423 113.989L-0.400447 86.431L24.652 85.8047ZM-30.4633 113.989L24.0257 86.431L0.225853 87.0573L-30.4633 113.989Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2782 85.8046L40.3097 113.362L39.6834 113.362L-32.3423 115.241L-32.3423 114.615L25.2782 85.8046ZM39.6834 112.736L25.2782 86.4309L-30.4634 114.615L39.6834 112.736Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.0001 113.989L-27.3318 90.1887L-1.02678 87.6835L-48.0001 120.252L-48.0001 120.878L0.852176 87.0572L-27.9582 89.5624L-48.0001 113.362L-48.0001 113.989Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.9999 120.878L-3.53184 90.1888L-32.3421 114.615L-47.9999 122.757L-47.9999 123.383L-31.7158 115.241L0.226016 87.0573L-0.400285 87.0573L-47.9999 120.252L-47.9999 120.878Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.797 61.3786L297.724 91.4415L287.703 95.8257L287.703 95.1994L332.797 61.3786ZM297.724 90.8152L325.908 67.0154L289.581 93.9468L297.724 90.8152Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.478 42.589L183.109 59.4994L129.246 97.078L128.62 97.7043L128.62 97.078L120.478 42.589ZM182.483 60.1257L121.73 43.8416L129.872 97.078L182.483 60.1257Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.109 59.4994L198.14 87.0571L197.514 87.0571L128.619 97.7043L129.246 97.078L183.109 59.4994ZM197.514 86.4307L183.109 60.1257L130.498 97.078L197.514 86.4307Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.104 43.2153L129.873 97.7043L121.104 90.8149L121.104 43.2153ZM129.246 97.078L121.104 46.3469L121.104 90.8149L129.246 97.078Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3937 10.6472L99.183 40.0839L81.02 77.6625L80.3937 78.2888L80.3937 77.6625L80.3937 10.6472ZM99.183 40.7102L81.02 12.5262L81.02 77.0362L99.183 40.7102Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0198 11.2735L121.73 90.8149L121.104 90.8149L81.6461 78.2887L81.0198 78.915L81.0198 78.2887L81.0198 11.2735ZM120.477 90.1886L81.0198 12.5261L81.0198 77.6624L120.477 90.1886Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8093 39.4577L81.0199 77.6627L24.6519 85.8047L24.6519 85.1784L99.8093 39.4577ZM81.0199 77.6627L98.5567 41.3367L25.9046 85.8047L81.0199 77.6627Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M640.455 377.145C641.711 377.145 642.34 376.517 642.34 375.26C642.34 374.003 641.711 373.375 640.455 373.375C639.198 373.375 638.569 374.003 638.569 375.26C638.569 376.517 639.826 377.145 640.455 377.145Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.542 377.774C632.285 377.774 631.656 378.402 631.656 379.659C631.656 380.916 632.285 381.544 633.542 381.544C634.799 381.544 635.427 380.916 635.427 379.659C635.427 378.402 634.799 377.774 633.542 377.774Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.072 367.09C272.815 367.09 272.186 368.347 272.186 368.976C272.186 370.232 273.443 370.861 274.072 370.861C275.328 370.861 275.957 369.604 275.957 368.976C275.957 368.347 275.328 367.09 274.072 367.09Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.79 370.232C677.533 370.232 676.276 371.489 676.276 372.746C676.276 374.632 677.533 375.888 678.79 375.888C680.675 375.888 681.932 374.632 681.932 373.375C681.932 371.489 680.675 370.232 678.79 370.232Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.903 328.127C538.018 328.127 536.761 329.384 536.761 331.269C536.761 333.154 538.018 334.411 539.903 334.411C541.789 334.411 543.046 333.154 543.046 331.269C543.046 329.384 541.789 328.127 539.903 328.127Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.729 341.324C552.472 341.324 551.844 341.953 551.844 343.209C551.844 344.466 553.101 345.095 553.729 345.095C554.986 345.095 555.615 344.466 555.615 343.209C555.615 341.953 554.986 341.324 553.729 341.324Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.866 372.746C440.609 372.746 439.981 373.375 439.981 374.632C439.981 375.888 440.609 376.517 441.866 376.517C443.123 376.517 443.752 375.888 443.752 374.632C443.752 373.375 443.123 372.746 441.866 372.746Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.926 291.677C428.669 291.677 428.04 292.934 428.04 293.562C428.04 294.819 429.297 295.448 429.926 295.448C431.183 295.448 431.811 294.191 431.811 293.562C432.439 292.934 431.183 291.677 429.926 291.677Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.242 362.063C419.242 363.948 420.499 365.205 422.385 365.205C424.27 365.205 425.527 363.948 425.527 362.063C425.527 360.177 424.27 358.92 422.385 358.92C420.499 358.92 419.242 360.177 419.242 362.063Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.453 330.64C367.71 330.64 368.967 329.383 368.967 328.127C368.967 326.87 367.71 325.613 366.453 325.613C365.196 325.613 363.939 326.87 363.939 328.127C363.939 329.383 365.196 330.64 366.453 330.64Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.829 333.783C345.086 333.783 346.343 332.526 346.343 331.269C346.343 330.012 345.086 328.755 343.829 328.755C342.572 328.755 341.315 330.012 341.315 331.269C341.315 332.526 342.572 333.783 343.829 333.783Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.498 335.04C283.498 333.154 281.613 331.269 279.728 331.269C277.842 331.269 275.957 333.154 275.957 335.04C275.957 336.925 277.842 338.81 279.728 338.81C281.613 338.182 283.498 336.925 283.498 335.04Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.62 297.961C671.877 297.961 672.505 296.705 672.505 296.076C672.505 294.819 671.248 294.191 670.62 294.191C669.363 294.191 668.735 295.448 668.735 296.076C668.735 296.705 669.363 297.961 670.62 297.961Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.735 335.039C668.735 336.296 669.991 337.553 671.248 337.553C672.505 337.553 673.762 336.296 673.762 335.039C673.762 333.783 672.505 332.526 671.248 332.526C669.991 332.526 668.735 333.783 668.735 335.039Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.913 303.617C631.028 303.617 629.771 304.874 629.771 306.76C629.771 308.645 631.028 309.902 632.913 309.902C634.799 309.902 636.056 308.645 636.056 306.76C636.684 305.503 634.799 303.617 632.913 303.617Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 260.255C586.408 260.255 587.665 258.998 587.665 257.112C587.665 255.227 586.408 253.97 584.523 253.97C582.638 253.97 581.381 255.227 581.381 257.112C581.381 258.998 582.638 260.255 584.523 260.255Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.014 297.961C560.014 299.847 561.271 301.104 563.156 301.104C565.041 301.104 566.298 299.847 566.298 297.961C566.298 296.076 565.041 294.819 563.156 294.819C561.271 294.819 560.014 296.076 560.014 297.961Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.844 338.182C553.101 338.182 553.729 336.925 553.729 335.668C553.729 334.411 552.472 333.154 551.216 333.154C549.959 333.154 548.831 333.336 548.702 335.668C548.573 338 550.587 338.182 551.844 338.182Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.027 302.989C495.912 302.989 497.169 301.732 497.169 299.847C497.169 297.961 495.913 296.704 494.027 296.704C492.142 296.704 490.885 297.961 490.885 299.847C490.885 301.103 492.142 302.989 494.027 302.989Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.04 270.31C429.297 270.31 430.554 269.053 430.554 267.796C430.554 266.539 429.297 265.282 428.04 265.282C426.783 265.282 425.527 266.539 425.527 267.796C425.527 269.053 426.783 270.31 428.04 270.31Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.393 315.558C376.508 315.558 374.623 316.815 374.623 319.328C374.623 321.214 376.508 323.099 378.393 323.099C380.279 323.099 382.164 321.842 382.164 319.328C381.536 316.815 380.279 315.558 378.393 315.558Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.508 302.989C378.393 302.989 379.65 301.732 379.65 299.847C379.65 297.961 378.393 296.704 376.508 296.704C374.623 296.704 373.366 297.961 373.366 299.847C373.366 301.732 374.623 302.989 376.508 302.989Z",
    fill: "#7F3F98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.416 272.824C406.673 272.824 407.93 271.567 407.93 270.31C407.93 269.053 406.673 267.796 405.416 267.796C404.159 267.796 402.903 269.053 402.903 270.31C402.274 271.567 403.531 272.824 405.416 272.824Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.407 338.182C311.15 338.182 309.893 339.439 309.893 340.695C309.893 341.952 311.15 343.209 312.407 343.209C313.664 343.209 314.92 341.952 314.92 340.695C314.92 339.439 313.664 338.182 312.407 338.182Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82 256.484C386.563 256.484 385.306 257.741 385.306 258.998C385.306 260.255 386.563 261.511 387.82 261.511C389.077 261.511 390.334 260.255 390.334 258.998C390.334 257.741 389.077 256.484 387.82 256.484Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.608 324.985C301.723 324.985 299.838 326.87 299.838 328.755C299.838 330.641 301.723 332.526 303.608 332.526C305.494 332.526 307.379 330.641 307.379 328.755C307.379 326.87 305.494 324.985 303.608 324.985Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.4 270.938C630.4 272.824 631.656 274.081 633.542 274.081C635.427 274.081 636.684 272.824 636.684 270.938C636.684 269.053 635.427 267.796 633.542 267.796C631.656 267.796 630.4 269.053 630.4 270.938Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.761 293.562C536.761 294.819 538.018 296.076 539.275 296.076C540.532 296.076 541.789 294.819 541.789 293.562C541.789 292.305 540.532 291.048 539.275 291.048C538.018 291.048 536.761 292.305 536.761 293.562Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.935 245.172C522.935 246.429 524.192 247.686 525.449 247.686C526.706 247.686 527.963 246.429 527.963 245.172C527.963 243.915 526.706 242.658 525.449 242.658C523.564 242.658 522.935 243.915 522.935 245.172Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.119 280.365C466.375 280.365 467.632 279.108 467.632 277.851C467.632 276.594 466.375 275.337 465.119 275.337C463.862 275.337 462.605 276.594 462.605 277.851C462.605 279.108 463.862 280.365 465.119 280.365Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.494 256.484C304.237 256.484 302.98 257.741 302.98 258.998C302.98 260.255 304.237 261.511 305.494 261.511C306.751 261.511 308.008 260.255 308.008 258.998C308.008 257.112 306.751 256.484 305.494 256.484Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.576 279.108C320.576 280.993 321.833 282.25 323.719 282.25C325.604 282.25 326.861 280.993 326.861 279.108C326.861 277.223 325.604 275.966 323.719 275.966C321.833 275.966 320.576 277.223 320.576 279.108Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.183 266.539C570.069 266.539 571.954 265.282 571.954 262.769C571.954 260.883 570.697 258.998 568.183 258.998C566.298 258.998 564.413 260.255 564.413 262.769C564.413 265.282 566.298 266.539 568.183 266.539Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.586 242.658C413.586 244.543 414.843 245.8 416.729 245.8C418.614 245.8 419.871 244.543 419.871 242.658C419.871 240.773 418.614 239.516 416.729 239.516C414.843 239.516 413.586 241.401 413.586 242.658Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.357 255.227C417.357 257.112 418.614 258.369 420.499 258.369C422.384 258.369 423.641 257.112 423.641 255.227C423.641 253.342 422.384 252.085 420.499 252.085C418.614 252.085 417.357 253.97 417.357 255.227Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.985 384.058C279.728 384.058 279.099 385.315 279.099 385.944C279.099 387 280.073 387.829 280.985 387.829C282.582 387.829 283.073 386.5 283.073 385.944C283.073 385.387 282.241 384.058 280.985 384.058Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.431 369.716C216.695 369.716 215.288 371.122 215.288 372.858C215.288 374.593 216.695 376 218.431 376C220.166 376 221.573 374.593 221.573 372.858C221.573 371.122 220.166 369.716 218.431 369.716Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.69 376.517C183.576 376.517 184.833 375.26 184.833 373.375C184.833 371.489 183.576 370.232 181.69 370.232C179.805 370.232 178.548 371.489 178.548 373.375C178.548 375.26 179.805 376.517 181.69 376.517Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.659 305.503C335.659 304.246 334.402 302.989 333.145 302.989C331.888 302.989 330.632 304.246 330.632 305.503C330.632 306.76 331.888 308.016 333.145 308.016C334.402 308.645 335.659 307.388 335.659 305.503Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.402 318.072C334.402 319.329 335.659 319.957 336.916 319.957C338.173 319.957 339.43 318.7 339.43 318.072C339.43 316.815 338.173 316.186 336.916 316.186C335.659 315.558 334.402 316.815 334.402 318.072Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.205 340.067C319.948 340.067 318.691 341.324 318.691 342.581C318.691 343.838 319.948 345.095 321.205 345.095C322.462 345.095 323.719 343.838 323.719 342.581C323.719 341.324 323.09 340.067 321.205 340.067Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.847 325.613C254.59 325.613 253.333 326.87 253.333 328.127C253.333 329.383 254.59 330.64 255.847 330.64C257.104 330.64 258.361 329.383 258.361 328.127C258.361 326.87 257.104 325.613 255.847 325.613Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.388 363.319C262.131 363.319 260.874 364.576 260.874 365.833C260.874 367.09 262.131 368.347 263.388 368.347C264.645 368.347 265.902 367.09 265.902 365.833C265.902 364.576 265.274 363.319 263.388 363.319Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.007 361.434C169.75 361.434 168.493 362.691 168.493 363.948C168.493 365.205 169.75 366.462 171.007 366.462C172.264 366.462 173.52 365.205 173.52 363.948C173.52 362.691 172.264 361.434 171.007 361.434Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.168 368.347C223.168 369.604 224.425 370.861 225.682 370.861C226.938 370.861 228.195 369.604 228.195 368.347C228.195 367.09 226.938 365.833 225.682 365.833C223.796 365.833 223.168 367.09 223.168 368.347Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.328 334.411C137.071 334.411 136.442 335.04 136.442 336.297C136.442 337.553 137.699 338.182 138.328 338.182C139.585 338.182 140.213 337.553 140.213 336.297C140.213 335.04 139.585 334.411 138.328 334.411Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84056 355.15C3.84056 357.035 5.09745 358.292 6.98278 358.292C8.86811 358.292 10.125 357.035 10.125 355.15C10.125 353.264 8.86811 352.007 6.98278 352.007C5.09745 352.007 3.84056 353.264 3.84056 355.15Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4647 363.948C24.3822 363.948 22.694 365.636 22.694 367.719C22.694 369.801 24.3822 371.489 26.4647 371.489C28.5472 371.489 30.2354 369.801 30.2354 367.719C30.2354 365.636 28.5472 363.948 26.4647 363.948Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.921 291.677C313.664 291.677 312.407 292.934 312.407 294.191C312.407 295.447 313.664 296.704 314.921 296.704C316.177 296.704 317.434 295.447 317.434 294.191C317.434 292.934 316.177 291.677 314.921 291.677Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.218 291.677C257.104 291.677 258.361 290.42 258.361 288.535C258.361 286.649 257.104 285.393 255.218 285.393C253.333 285.393 252.076 286.649 252.076 288.535C252.076 290.42 253.333 291.677 255.218 291.677Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.741 264.025C213.741 265.911 215.626 267.796 217.512 267.796C219.397 267.796 221.282 265.911 221.282 264.025C221.282 262.14 219.397 260.255 217.512 260.255C215.626 260.255 213.741 261.512 213.741 264.025Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.512 302.36C218.769 302.36 220.026 301.103 220.026 299.847C220.026 298.59 218.769 297.333 217.512 297.333C216.255 297.333 214.998 298.59 214.998 299.847C214.998 301.103 216.255 302.36 217.512 302.36Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.442 331.269C137.699 331.269 139.585 330.012 139.585 328.755C139.585 327.498 138.328 326.241 136.442 326.241C135.185 326.241 133.3 327.498 133.3 328.755C133.3 330.012 134.557 331.269 136.442 331.269Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.121 253.97C171.007 253.97 172.892 252.085 172.892 250.2C172.892 248.314 171.007 246.429 169.121 246.429C167.236 246.429 165.351 248.314 165.351 250.2C165.351 252.085 167.236 253.97 169.121 253.97Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.502 322.471C123.245 322.471 122.617 323.099 122.617 324.356C122.617 325.613 123.245 326.241 124.502 326.241C125.759 326.241 126.387 325.613 126.387 324.356C126.387 323.099 125.13 322.471 124.502 322.471Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.754 287.278C145.869 287.278 144.612 288.535 144.612 290.42C144.612 292.305 145.869 293.562 147.754 293.562C149.64 293.562 150.897 292.305 150.897 290.42C150.897 289.163 149.64 287.278 147.754 287.278Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.36 286.649C121.36 287.906 122.617 289.163 123.874 289.163C125.13 289.163 126.387 287.906 126.387 286.649C126.387 285.392 125.13 284.136 123.874 284.136C122.617 284.136 121.36 285.392 121.36 286.649Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6254 295.448C80.5108 295.448 81.7676 294.191 81.7676 292.305C81.7676 290.42 80.5108 289.163 78.6254 289.163C76.7401 289.163 75.4832 290.42 75.4832 292.305C75.4832 294.191 76.7401 295.448 78.6254 295.448Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7535 287.278C10.7535 289.163 12.6388 291.049 14.5242 291.049C16.4095 291.049 18.2949 289.163 18.2949 287.278C18.2949 285.393 16.4095 283.507 14.5242 283.507C12.6388 283.507 10.7535 284.764 10.7535 287.278Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6389 263.397C14.5242 263.397 15.7811 262.14 15.7811 260.255C15.7811 258.369 14.5242 257.113 12.6389 257.113C10.7536 257.113 9.49669 258.369 9.49669 260.255C9.49669 262.14 10.7536 263.397 12.6389 263.397Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.925 288.535C294.81 288.535 296.067 287.278 296.067 285.392C296.067 283.507 294.81 282.25 292.925 282.25C291.04 282.25 289.783 283.507 289.783 285.392C289.783 287.278 291.668 288.535 292.925 288.535Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.691 257.741C318.691 258.998 319.948 259.626 320.577 259.626C321.833 259.626 322.462 258.998 322.462 257.741C322.462 256.484 321.205 255.856 320.577 255.856C319.948 255.856 318.691 257.112 318.691 257.741Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7172 273.452C50.9741 273.452 52.231 272.195 52.231 270.938C52.231 269.681 50.9741 268.424 49.7172 268.424C48.4603 268.424 47.2034 269.681 47.2034 270.938C47.2034 272.195 48.4603 273.452 49.7172 273.452Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.153 258.998C153.41 258.998 154.667 257.741 154.667 256.484C154.667 255.227 153.41 253.97 152.153 253.97C150.897 253.97 149.64 255.227 149.64 256.484C149.64 257.741 150.897 258.998 152.153 258.998Z",
    fill: "#00A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95537 248.314C1.95537 250.199 3.21225 251.456 5.09759 251.456C6.98292 251.456 8.23981 250.199 8.23981 248.314C8.23981 246.429 6.98292 245.172 5.09759 245.172C3.21225 245.172 1.95537 246.429 1.95537 248.314Z",
    fill: "#F26522"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 751.573,
    height: 386.434,
    fill: "white",
    transform: "translate(1483.57 386.434) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 751.573,
    height: 386.434,
    fill: "white",
    transform: "translate(703.573 386.434) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDots);
export default __webpack_public_path__ + "static/media/bg-dots.c02b02af51129c01920044b676fd5cea.svg";
export { ForwardRef as ReactComponent };